/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import $protobuf from "protobufjs/minimal.js";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const SetInfo = $root.SetInfo = (() => {

    /**
     * Properties of a SetInfo.
     * @exports ISetInfo
     * @interface ISetInfo
     * @property {string|null} [ruleset] Currently, one of: "MS", "Lynx", "Lynx (Strict)", or "Steam"
     * @property {string|null} [setType] Currently, one of: "DAT", "C2M", or "C2G"
     * @property {string|null} [setName] SetInfo setName
     * @property {Array.<ILevelInfo>|null} [levels] SetInfo levels
     * @property {number|null} [currentLevel] SetInfo currentLevel
     */

    /**
     * Constructs a new SetInfo.
     * @exports SetInfo
     * @classdesc Represents a SetInfo.
     * @implements ISetInfo
     * @constructor
     * @param {ISetInfo=} [properties] Properties to set
     */
    function SetInfo(properties) {
        this.levels = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Currently, one of: "MS", "Lynx", "Lynx (Strict)", or "Steam"
     * @member {string} ruleset
     * @memberof SetInfo
     * @instance
     */
    SetInfo.prototype.ruleset = "";

    /**
     * Currently, one of: "DAT", "C2M", or "C2G"
     * @member {string} setType
     * @memberof SetInfo
     * @instance
     */
    SetInfo.prototype.setType = "";

    /**
     * SetInfo setName.
     * @member {string} setName
     * @memberof SetInfo
     * @instance
     */
    SetInfo.prototype.setName = "";

    /**
     * SetInfo levels.
     * @member {Array.<ILevelInfo>} levels
     * @memberof SetInfo
     * @instance
     */
    SetInfo.prototype.levels = $util.emptyArray;

    /**
     * SetInfo currentLevel.
     * @member {number} currentLevel
     * @memberof SetInfo
     * @instance
     */
    SetInfo.prototype.currentLevel = 0;

    /**
     * Creates a new SetInfo instance using the specified properties.
     * @function create
     * @memberof SetInfo
     * @static
     * @param {ISetInfo=} [properties] Properties to set
     * @returns {SetInfo} SetInfo instance
     */
    SetInfo.create = function create(properties) {
        return new SetInfo(properties);
    };

    /**
     * Encodes the specified SetInfo message. Does not implicitly {@link SetInfo.verify|verify} messages.
     * @function encode
     * @memberof SetInfo
     * @static
     * @param {ISetInfo} message SetInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SetInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ruleset != null && Object.hasOwnProperty.call(message, "ruleset"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.ruleset);
        if (message.setType != null && Object.hasOwnProperty.call(message, "setType"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.setType);
        if (message.setName != null && Object.hasOwnProperty.call(message, "setName"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.setName);
        if (message.levels != null && message.levels.length)
            for (let i = 0; i < message.levels.length; ++i)
                $root.LevelInfo.encode(message.levels[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.currentLevel != null && Object.hasOwnProperty.call(message, "currentLevel"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.currentLevel);
        return writer;
    };

    /**
     * Encodes the specified SetInfo message, length delimited. Does not implicitly {@link SetInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SetInfo
     * @static
     * @param {ISetInfo} message SetInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SetInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SetInfo message from the specified reader or buffer.
     * @function decode
     * @memberof SetInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SetInfo} SetInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SetInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SetInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.ruleset = reader.string();
                    break;
                }
            case 2: {
                    message.setType = reader.string();
                    break;
                }
            case 3: {
                    message.setName = reader.string();
                    break;
                }
            case 4: {
                    if (!(message.levels && message.levels.length))
                        message.levels = [];
                    message.levels.push($root.LevelInfo.decode(reader, reader.uint32()));
                    break;
                }
            case 5: {
                    message.currentLevel = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SetInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SetInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SetInfo} SetInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SetInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SetInfo message.
     * @function verify
     * @memberof SetInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SetInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ruleset != null && message.hasOwnProperty("ruleset"))
            if (!$util.isString(message.ruleset))
                return "ruleset: string expected";
        if (message.setType != null && message.hasOwnProperty("setType"))
            if (!$util.isString(message.setType))
                return "setType: string expected";
        if (message.setName != null && message.hasOwnProperty("setName"))
            if (!$util.isString(message.setName))
                return "setName: string expected";
        if (message.levels != null && message.hasOwnProperty("levels")) {
            if (!Array.isArray(message.levels))
                return "levels: array expected";
            for (let i = 0; i < message.levels.length; ++i) {
                let error = $root.LevelInfo.verify(message.levels[i]);
                if (error)
                    return "levels." + error;
            }
        }
        if (message.currentLevel != null && message.hasOwnProperty("currentLevel"))
            if (!$util.isInteger(message.currentLevel))
                return "currentLevel: integer expected";
        return null;
    };

    /**
     * Creates a SetInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SetInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SetInfo} SetInfo
     */
    SetInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.SetInfo)
            return object;
        let message = new $root.SetInfo();
        if (object.ruleset != null)
            message.ruleset = String(object.ruleset);
        if (object.setType != null)
            message.setType = String(object.setType);
        if (object.setName != null)
            message.setName = String(object.setName);
        if (object.levels) {
            if (!Array.isArray(object.levels))
                throw TypeError(".SetInfo.levels: array expected");
            message.levels = [];
            for (let i = 0; i < object.levels.length; ++i) {
                if (typeof object.levels[i] !== "object")
                    throw TypeError(".SetInfo.levels: object expected");
                message.levels[i] = $root.LevelInfo.fromObject(object.levels[i]);
            }
        }
        if (object.currentLevel != null)
            message.currentLevel = object.currentLevel | 0;
        return message;
    };

    /**
     * Creates a plain object from a SetInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SetInfo
     * @static
     * @param {SetInfo} message SetInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SetInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.levels = [];
        if (options.defaults) {
            object.ruleset = "";
            object.setType = "";
            object.setName = "";
            object.currentLevel = 0;
        }
        if (message.ruleset != null && message.hasOwnProperty("ruleset"))
            object.ruleset = message.ruleset;
        if (message.setType != null && message.hasOwnProperty("setType"))
            object.setType = message.setType;
        if (message.setName != null && message.hasOwnProperty("setName"))
            object.setName = message.setName;
        if (message.levels && message.levels.length) {
            object.levels = [];
            for (let j = 0; j < message.levels.length; ++j)
                object.levels[j] = $root.LevelInfo.toObject(message.levels[j], options);
        }
        if (message.currentLevel != null && message.hasOwnProperty("currentLevel"))
            object.currentLevel = message.currentLevel;
        return object;
    };

    /**
     * Converts this SetInfo to JSON.
     * @function toJSON
     * @memberof SetInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SetInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for SetInfo
     * @function getTypeUrl
     * @memberof SetInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    SetInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/SetInfo";
    };

    return SetInfo;
})();

export const LevelInfo = $root.LevelInfo = (() => {

    /**
     * Properties of a LevelInfo.
     * @exports ILevelInfo
     * @interface ILevelInfo
     * @property {number|null} [levelNumber] LevelInfo levelNumber
     * @property {string|null} [title] LevelInfo title
     * @property {IScriptState|null} [scriptState] LevelInfo scriptState
     * @property {Array.<IAttemptInfo>|null} [attempts] LevelInfo attempts
     * @property {string|null} [levelFilePath] LevelInfo levelFilePath
     * @property {string|null} [prologueText] LevelInfo prologueText
     * @property {string|null} [epilogueText] LevelInfo epilogueText
     */

    /**
     * Constructs a new LevelInfo.
     * @exports LevelInfo
     * @classdesc Represents a LevelInfo.
     * @implements ILevelInfo
     * @constructor
     * @param {ILevelInfo=} [properties] Properties to set
     */
    function LevelInfo(properties) {
        this.attempts = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * LevelInfo levelNumber.
     * @member {number} levelNumber
     * @memberof LevelInfo
     * @instance
     */
    LevelInfo.prototype.levelNumber = 0;

    /**
     * LevelInfo title.
     * @member {string} title
     * @memberof LevelInfo
     * @instance
     */
    LevelInfo.prototype.title = "";

    /**
     * LevelInfo scriptState.
     * @member {IScriptState|null|undefined} scriptState
     * @memberof LevelInfo
     * @instance
     */
    LevelInfo.prototype.scriptState = null;

    /**
     * LevelInfo attempts.
     * @member {Array.<IAttemptInfo>} attempts
     * @memberof LevelInfo
     * @instance
     */
    LevelInfo.prototype.attempts = $util.emptyArray;

    /**
     * LevelInfo levelFilePath.
     * @member {string} levelFilePath
     * @memberof LevelInfo
     * @instance
     */
    LevelInfo.prototype.levelFilePath = "";

    /**
     * LevelInfo prologueText.
     * @member {string} prologueText
     * @memberof LevelInfo
     * @instance
     */
    LevelInfo.prototype.prologueText = "";

    /**
     * LevelInfo epilogueText.
     * @member {string} epilogueText
     * @memberof LevelInfo
     * @instance
     */
    LevelInfo.prototype.epilogueText = "";

    /**
     * Creates a new LevelInfo instance using the specified properties.
     * @function create
     * @memberof LevelInfo
     * @static
     * @param {ILevelInfo=} [properties] Properties to set
     * @returns {LevelInfo} LevelInfo instance
     */
    LevelInfo.create = function create(properties) {
        return new LevelInfo(properties);
    };

    /**
     * Encodes the specified LevelInfo message. Does not implicitly {@link LevelInfo.verify|verify} messages.
     * @function encode
     * @memberof LevelInfo
     * @static
     * @param {ILevelInfo} message LevelInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LevelInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.levelNumber != null && Object.hasOwnProperty.call(message, "levelNumber"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.levelNumber);
        if (message.title != null && Object.hasOwnProperty.call(message, "title"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.title);
        if (message.scriptState != null && Object.hasOwnProperty.call(message, "scriptState"))
            $root.ScriptState.encode(message.scriptState, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.attempts != null && message.attempts.length)
            for (let i = 0; i < message.attempts.length; ++i)
                $root.AttemptInfo.encode(message.attempts[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.levelFilePath != null && Object.hasOwnProperty.call(message, "levelFilePath"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.levelFilePath);
        if (message.prologueText != null && Object.hasOwnProperty.call(message, "prologueText"))
            writer.uint32(/* id 16, wireType 2 =*/130).string(message.prologueText);
        if (message.epilogueText != null && Object.hasOwnProperty.call(message, "epilogueText"))
            writer.uint32(/* id 17, wireType 2 =*/138).string(message.epilogueText);
        return writer;
    };

    /**
     * Encodes the specified LevelInfo message, length delimited. Does not implicitly {@link LevelInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LevelInfo
     * @static
     * @param {ILevelInfo} message LevelInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LevelInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a LevelInfo message from the specified reader or buffer.
     * @function decode
     * @memberof LevelInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LevelInfo} LevelInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LevelInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.LevelInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.levelNumber = reader.int32();
                    break;
                }
            case 2: {
                    message.title = reader.string();
                    break;
                }
            case 3: {
                    message.scriptState = $root.ScriptState.decode(reader, reader.uint32());
                    break;
                }
            case 4: {
                    if (!(message.attempts && message.attempts.length))
                        message.attempts = [];
                    message.attempts.push($root.AttemptInfo.decode(reader, reader.uint32()));
                    break;
                }
            case 5: {
                    message.levelFilePath = reader.string();
                    break;
                }
            case 16: {
                    message.prologueText = reader.string();
                    break;
                }
            case 17: {
                    message.epilogueText = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a LevelInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LevelInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LevelInfo} LevelInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LevelInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a LevelInfo message.
     * @function verify
     * @memberof LevelInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    LevelInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.levelNumber != null && message.hasOwnProperty("levelNumber"))
            if (!$util.isInteger(message.levelNumber))
                return "levelNumber: integer expected";
        if (message.title != null && message.hasOwnProperty("title"))
            if (!$util.isString(message.title))
                return "title: string expected";
        if (message.scriptState != null && message.hasOwnProperty("scriptState")) {
            let error = $root.ScriptState.verify(message.scriptState);
            if (error)
                return "scriptState." + error;
        }
        if (message.attempts != null && message.hasOwnProperty("attempts")) {
            if (!Array.isArray(message.attempts))
                return "attempts: array expected";
            for (let i = 0; i < message.attempts.length; ++i) {
                let error = $root.AttemptInfo.verify(message.attempts[i]);
                if (error)
                    return "attempts." + error;
            }
        }
        if (message.levelFilePath != null && message.hasOwnProperty("levelFilePath"))
            if (!$util.isString(message.levelFilePath))
                return "levelFilePath: string expected";
        if (message.prologueText != null && message.hasOwnProperty("prologueText"))
            if (!$util.isString(message.prologueText))
                return "prologueText: string expected";
        if (message.epilogueText != null && message.hasOwnProperty("epilogueText"))
            if (!$util.isString(message.epilogueText))
                return "epilogueText: string expected";
        return null;
    };

    /**
     * Creates a LevelInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LevelInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LevelInfo} LevelInfo
     */
    LevelInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.LevelInfo)
            return object;
        let message = new $root.LevelInfo();
        if (object.levelNumber != null)
            message.levelNumber = object.levelNumber | 0;
        if (object.title != null)
            message.title = String(object.title);
        if (object.scriptState != null) {
            if (typeof object.scriptState !== "object")
                throw TypeError(".LevelInfo.scriptState: object expected");
            message.scriptState = $root.ScriptState.fromObject(object.scriptState);
        }
        if (object.attempts) {
            if (!Array.isArray(object.attempts))
                throw TypeError(".LevelInfo.attempts: array expected");
            message.attempts = [];
            for (let i = 0; i < object.attempts.length; ++i) {
                if (typeof object.attempts[i] !== "object")
                    throw TypeError(".LevelInfo.attempts: object expected");
                message.attempts[i] = $root.AttemptInfo.fromObject(object.attempts[i]);
            }
        }
        if (object.levelFilePath != null)
            message.levelFilePath = String(object.levelFilePath);
        if (object.prologueText != null)
            message.prologueText = String(object.prologueText);
        if (object.epilogueText != null)
            message.epilogueText = String(object.epilogueText);
        return message;
    };

    /**
     * Creates a plain object from a LevelInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LevelInfo
     * @static
     * @param {LevelInfo} message LevelInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LevelInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.attempts = [];
        if (options.defaults) {
            object.levelNumber = 0;
            object.title = "";
            object.scriptState = null;
            object.levelFilePath = "";
            object.prologueText = "";
            object.epilogueText = "";
        }
        if (message.levelNumber != null && message.hasOwnProperty("levelNumber"))
            object.levelNumber = message.levelNumber;
        if (message.title != null && message.hasOwnProperty("title"))
            object.title = message.title;
        if (message.scriptState != null && message.hasOwnProperty("scriptState"))
            object.scriptState = $root.ScriptState.toObject(message.scriptState, options);
        if (message.attempts && message.attempts.length) {
            object.attempts = [];
            for (let j = 0; j < message.attempts.length; ++j)
                object.attempts[j] = $root.AttemptInfo.toObject(message.attempts[j], options);
        }
        if (message.levelFilePath != null && message.hasOwnProperty("levelFilePath"))
            object.levelFilePath = message.levelFilePath;
        if (message.prologueText != null && message.hasOwnProperty("prologueText"))
            object.prologueText = message.prologueText;
        if (message.epilogueText != null && message.hasOwnProperty("epilogueText"))
            object.epilogueText = message.epilogueText;
        return object;
    };

    /**
     * Converts this LevelInfo to JSON.
     * @function toJSON
     * @memberof LevelInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LevelInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for LevelInfo
     * @function getTypeUrl
     * @memberof LevelInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    LevelInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/LevelInfo";
    };

    return LevelInfo;
})();

export const ScriptState = $root.ScriptState = (() => {

    /**
     * Properties of a ScriptState.
     * @exports IScriptState
     * @interface IScriptState
     * @property {ScriptState.IScriptVariables|null} [variables] ScriptState variables
     * @property {number|null} [currentLine] ScriptState currentLine
     * @property {ScriptState.IScriptMusicState|null} [music] ScriptState music
     * @property {string|null} [scriptTitle] `scriptTitle` is the title of the whole levelset (which is what is
     * used as the list name)
     * @property {string|null} [gameTitle] `gameName` is the current title set by `game`. In CC2, used for the
     * save file location.
     * @property {string|null} [scriptPath] ScriptState scriptPath
     * @property {string|null} [fsPosition] ScriptState fsPosition
     */

    /**
     * Constructs a new ScriptState.
     * @exports ScriptState
     * @classdesc Represents a ScriptState.
     * @implements IScriptState
     * @constructor
     * @param {IScriptState=} [properties] Properties to set
     */
    function ScriptState(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ScriptState variables.
     * @member {ScriptState.IScriptVariables|null|undefined} variables
     * @memberof ScriptState
     * @instance
     */
    ScriptState.prototype.variables = null;

    /**
     * ScriptState currentLine.
     * @member {number} currentLine
     * @memberof ScriptState
     * @instance
     */
    ScriptState.prototype.currentLine = 0;

    /**
     * ScriptState music.
     * @member {ScriptState.IScriptMusicState|null|undefined} music
     * @memberof ScriptState
     * @instance
     */
    ScriptState.prototype.music = null;

    /**
     * `scriptTitle` is the title of the whole levelset (which is what is
     * used as the list name)
     * @member {string} scriptTitle
     * @memberof ScriptState
     * @instance
     */
    ScriptState.prototype.scriptTitle = "";

    /**
     * `gameName` is the current title set by `game`. In CC2, used for the
     * save file location.
     * @member {string} gameTitle
     * @memberof ScriptState
     * @instance
     */
    ScriptState.prototype.gameTitle = "";

    /**
     * ScriptState scriptPath.
     * @member {string} scriptPath
     * @memberof ScriptState
     * @instance
     */
    ScriptState.prototype.scriptPath = "";

    /**
     * ScriptState fsPosition.
     * @member {string} fsPosition
     * @memberof ScriptState
     * @instance
     */
    ScriptState.prototype.fsPosition = "";

    /**
     * Creates a new ScriptState instance using the specified properties.
     * @function create
     * @memberof ScriptState
     * @static
     * @param {IScriptState=} [properties] Properties to set
     * @returns {ScriptState} ScriptState instance
     */
    ScriptState.create = function create(properties) {
        return new ScriptState(properties);
    };

    /**
     * Encodes the specified ScriptState message. Does not implicitly {@link ScriptState.verify|verify} messages.
     * @function encode
     * @memberof ScriptState
     * @static
     * @param {IScriptState} message ScriptState message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ScriptState.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.variables != null && Object.hasOwnProperty.call(message, "variables"))
            $root.ScriptState.ScriptVariables.encode(message.variables, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.currentLine != null && Object.hasOwnProperty.call(message, "currentLine"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.currentLine);
        if (message.music != null && Object.hasOwnProperty.call(message, "music"))
            $root.ScriptState.ScriptMusicState.encode(message.music, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.scriptTitle != null && Object.hasOwnProperty.call(message, "scriptTitle"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.scriptTitle);
        if (message.gameTitle != null && Object.hasOwnProperty.call(message, "gameTitle"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.gameTitle);
        if (message.scriptPath != null && Object.hasOwnProperty.call(message, "scriptPath"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.scriptPath);
        if (message.fsPosition != null && Object.hasOwnProperty.call(message, "fsPosition"))
            writer.uint32(/* id 16, wireType 2 =*/130).string(message.fsPosition);
        return writer;
    };

    /**
     * Encodes the specified ScriptState message, length delimited. Does not implicitly {@link ScriptState.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScriptState
     * @static
     * @param {IScriptState} message ScriptState message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ScriptState.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ScriptState message from the specified reader or buffer.
     * @function decode
     * @memberof ScriptState
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScriptState} ScriptState
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ScriptState.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ScriptState();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.variables = $root.ScriptState.ScriptVariables.decode(reader, reader.uint32());
                    break;
                }
            case 2: {
                    message.currentLine = reader.int32();
                    break;
                }
            case 3: {
                    message.music = $root.ScriptState.ScriptMusicState.decode(reader, reader.uint32());
                    break;
                }
            case 4: {
                    message.scriptTitle = reader.string();
                    break;
                }
            case 5: {
                    message.gameTitle = reader.string();
                    break;
                }
            case 6: {
                    message.scriptPath = reader.string();
                    break;
                }
            case 16: {
                    message.fsPosition = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ScriptState message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScriptState
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScriptState} ScriptState
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ScriptState.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ScriptState message.
     * @function verify
     * @memberof ScriptState
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ScriptState.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.variables != null && message.hasOwnProperty("variables")) {
            let error = $root.ScriptState.ScriptVariables.verify(message.variables);
            if (error)
                return "variables." + error;
        }
        if (message.currentLine != null && message.hasOwnProperty("currentLine"))
            if (!$util.isInteger(message.currentLine))
                return "currentLine: integer expected";
        if (message.music != null && message.hasOwnProperty("music")) {
            let error = $root.ScriptState.ScriptMusicState.verify(message.music);
            if (error)
                return "music." + error;
        }
        if (message.scriptTitle != null && message.hasOwnProperty("scriptTitle"))
            if (!$util.isString(message.scriptTitle))
                return "scriptTitle: string expected";
        if (message.gameTitle != null && message.hasOwnProperty("gameTitle"))
            if (!$util.isString(message.gameTitle))
                return "gameTitle: string expected";
        if (message.scriptPath != null && message.hasOwnProperty("scriptPath"))
            if (!$util.isString(message.scriptPath))
                return "scriptPath: string expected";
        if (message.fsPosition != null && message.hasOwnProperty("fsPosition"))
            if (!$util.isString(message.fsPosition))
                return "fsPosition: string expected";
        return null;
    };

    /**
     * Creates a ScriptState message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScriptState
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScriptState} ScriptState
     */
    ScriptState.fromObject = function fromObject(object) {
        if (object instanceof $root.ScriptState)
            return object;
        let message = new $root.ScriptState();
        if (object.variables != null) {
            if (typeof object.variables !== "object")
                throw TypeError(".ScriptState.variables: object expected");
            message.variables = $root.ScriptState.ScriptVariables.fromObject(object.variables);
        }
        if (object.currentLine != null)
            message.currentLine = object.currentLine | 0;
        if (object.music != null) {
            if (typeof object.music !== "object")
                throw TypeError(".ScriptState.music: object expected");
            message.music = $root.ScriptState.ScriptMusicState.fromObject(object.music);
        }
        if (object.scriptTitle != null)
            message.scriptTitle = String(object.scriptTitle);
        if (object.gameTitle != null)
            message.gameTitle = String(object.gameTitle);
        if (object.scriptPath != null)
            message.scriptPath = String(object.scriptPath);
        if (object.fsPosition != null)
            message.fsPosition = String(object.fsPosition);
        return message;
    };

    /**
     * Creates a plain object from a ScriptState message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScriptState
     * @static
     * @param {ScriptState} message ScriptState
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ScriptState.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.variables = null;
            object.currentLine = 0;
            object.music = null;
            object.scriptTitle = "";
            object.gameTitle = "";
            object.scriptPath = "";
            object.fsPosition = "";
        }
        if (message.variables != null && message.hasOwnProperty("variables"))
            object.variables = $root.ScriptState.ScriptVariables.toObject(message.variables, options);
        if (message.currentLine != null && message.hasOwnProperty("currentLine"))
            object.currentLine = message.currentLine;
        if (message.music != null && message.hasOwnProperty("music"))
            object.music = $root.ScriptState.ScriptMusicState.toObject(message.music, options);
        if (message.scriptTitle != null && message.hasOwnProperty("scriptTitle"))
            object.scriptTitle = message.scriptTitle;
        if (message.gameTitle != null && message.hasOwnProperty("gameTitle"))
            object.gameTitle = message.gameTitle;
        if (message.scriptPath != null && message.hasOwnProperty("scriptPath"))
            object.scriptPath = message.scriptPath;
        if (message.fsPosition != null && message.hasOwnProperty("fsPosition"))
            object.fsPosition = message.fsPosition;
        return object;
    };

    /**
     * Converts this ScriptState to JSON.
     * @function toJSON
     * @memberof ScriptState
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ScriptState.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ScriptState
     * @function getTypeUrl
     * @memberof ScriptState
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ScriptState.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ScriptState";
    };

    ScriptState.ScriptMusicState = (function() {

        /**
         * Properties of a ScriptMusicState.
         * @memberof ScriptState
         * @interface IScriptMusicState
         * @property {boolean|null} [repeating] ScriptMusicState repeating
         * @property {string|null} [path] ScriptMusicState path
         * @property {string|null} [id] ScriptMusicState id
         */

        /**
         * Constructs a new ScriptMusicState.
         * @memberof ScriptState
         * @classdesc Represents a ScriptMusicState.
         * @implements IScriptMusicState
         * @constructor
         * @param {ScriptState.IScriptMusicState=} [properties] Properties to set
         */
        function ScriptMusicState(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ScriptMusicState repeating.
         * @member {boolean} repeating
         * @memberof ScriptState.ScriptMusicState
         * @instance
         */
        ScriptMusicState.prototype.repeating = false;

        /**
         * ScriptMusicState path.
         * @member {string|null|undefined} path
         * @memberof ScriptState.ScriptMusicState
         * @instance
         */
        ScriptMusicState.prototype.path = null;

        /**
         * ScriptMusicState id.
         * @member {string|null|undefined} id
         * @memberof ScriptState.ScriptMusicState
         * @instance
         */
        ScriptMusicState.prototype.id = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * ScriptMusicState musicSelector.
         * @member {"path"|"id"|undefined} musicSelector
         * @memberof ScriptState.ScriptMusicState
         * @instance
         */
        Object.defineProperty(ScriptMusicState.prototype, "musicSelector", {
            get: $util.oneOfGetter($oneOfFields = ["path", "id"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ScriptMusicState instance using the specified properties.
         * @function create
         * @memberof ScriptState.ScriptMusicState
         * @static
         * @param {ScriptState.IScriptMusicState=} [properties] Properties to set
         * @returns {ScriptState.ScriptMusicState} ScriptMusicState instance
         */
        ScriptMusicState.create = function create(properties) {
            return new ScriptMusicState(properties);
        };

        /**
         * Encodes the specified ScriptMusicState message. Does not implicitly {@link ScriptState.ScriptMusicState.verify|verify} messages.
         * @function encode
         * @memberof ScriptState.ScriptMusicState
         * @static
         * @param {ScriptState.IScriptMusicState} message ScriptMusicState message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ScriptMusicState.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.repeating != null && Object.hasOwnProperty.call(message, "repeating"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.repeating);
            if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.path);
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified ScriptMusicState message, length delimited. Does not implicitly {@link ScriptState.ScriptMusicState.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ScriptState.ScriptMusicState
         * @static
         * @param {ScriptState.IScriptMusicState} message ScriptMusicState message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ScriptMusicState.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ScriptMusicState message from the specified reader or buffer.
         * @function decode
         * @memberof ScriptState.ScriptMusicState
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ScriptState.ScriptMusicState} ScriptMusicState
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ScriptMusicState.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ScriptState.ScriptMusicState();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.repeating = reader.bool();
                        break;
                    }
                case 2: {
                        message.path = reader.string();
                        break;
                    }
                case 3: {
                        message.id = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ScriptMusicState message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ScriptState.ScriptMusicState
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ScriptState.ScriptMusicState} ScriptMusicState
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ScriptMusicState.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ScriptMusicState message.
         * @function verify
         * @memberof ScriptState.ScriptMusicState
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ScriptMusicState.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.repeating != null && message.hasOwnProperty("repeating"))
                if (typeof message.repeating !== "boolean")
                    return "repeating: boolean expected";
            if (message.path != null && message.hasOwnProperty("path")) {
                properties.musicSelector = 1;
                if (!$util.isString(message.path))
                    return "path: string expected";
            }
            if (message.id != null && message.hasOwnProperty("id")) {
                if (properties.musicSelector === 1)
                    return "musicSelector: multiple values";
                properties.musicSelector = 1;
                if (!$util.isString(message.id))
                    return "id: string expected";
            }
            return null;
        };

        /**
         * Creates a ScriptMusicState message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ScriptState.ScriptMusicState
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ScriptState.ScriptMusicState} ScriptMusicState
         */
        ScriptMusicState.fromObject = function fromObject(object) {
            if (object instanceof $root.ScriptState.ScriptMusicState)
                return object;
            let message = new $root.ScriptState.ScriptMusicState();
            if (object.repeating != null)
                message.repeating = Boolean(object.repeating);
            if (object.path != null)
                message.path = String(object.path);
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a ScriptMusicState message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ScriptState.ScriptMusicState
         * @static
         * @param {ScriptState.ScriptMusicState} message ScriptMusicState
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ScriptMusicState.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.repeating = false;
            if (message.repeating != null && message.hasOwnProperty("repeating"))
                object.repeating = message.repeating;
            if (message.path != null && message.hasOwnProperty("path")) {
                object.path = message.path;
                if (options.oneofs)
                    object.musicSelector = "path";
            }
            if (message.id != null && message.hasOwnProperty("id")) {
                object.id = message.id;
                if (options.oneofs)
                    object.musicSelector = "id";
            }
            return object;
        };

        /**
         * Converts this ScriptMusicState to JSON.
         * @function toJSON
         * @memberof ScriptState.ScriptMusicState
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ScriptMusicState.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ScriptMusicState
         * @function getTypeUrl
         * @memberof ScriptState.ScriptMusicState
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ScriptMusicState.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/ScriptState.ScriptMusicState";
        };

        return ScriptMusicState;
    })();

    ScriptState.ScriptVariables = (function() {

        /**
         * Properties of a ScriptVariables.
         * @memberof ScriptState
         * @interface IScriptVariables
         * @property {number|null} [enter] ScriptVariables enter
         * @property {number|null} [exit] ScriptVariables exit
         * @property {number|null} [flags] ScriptVariables flags
         * @property {number|null} [gender] ScriptVariables gender
         * @property {number|null} [score] Unused (i.e. always 0) when used in `LevelInfo` (since the emulator is
         * expected to calculate that in real time), but should be set in a
         * solution's `LevelStateInfo`
         * @property {number|null} [keys] ScriptVariables keys
         * @property {number|null} [level] ScriptVariables level
         * @property {number|null} [menu] ScriptVariables menu
         * @property {number|null} [reg1] ScriptVariables reg1
         * @property {number|null} [reg2] ScriptVariables reg2
         * @property {number|null} [reg3] ScriptVariables reg3
         * @property {number|null} [reg4] ScriptVariables reg4
         * @property {number|null} [result] ScriptVariables result
         * @property {number|null} [speed] ScriptVariables speed
         * @property {number|null} [tleft] ScriptVariables tleft
         * @property {number|null} [tools] ScriptVariables tools
         */

        /**
         * Constructs a new ScriptVariables.
         * @memberof ScriptState
         * @classdesc Represents a ScriptVariables.
         * @implements IScriptVariables
         * @constructor
         * @param {ScriptState.IScriptVariables=} [properties] Properties to set
         */
        function ScriptVariables(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ScriptVariables enter.
         * @member {number} enter
         * @memberof ScriptState.ScriptVariables
         * @instance
         */
        ScriptVariables.prototype.enter = 0;

        /**
         * ScriptVariables exit.
         * @member {number} exit
         * @memberof ScriptState.ScriptVariables
         * @instance
         */
        ScriptVariables.prototype.exit = 0;

        /**
         * ScriptVariables flags.
         * @member {number} flags
         * @memberof ScriptState.ScriptVariables
         * @instance
         */
        ScriptVariables.prototype.flags = 0;

        /**
         * ScriptVariables gender.
         * @member {number} gender
         * @memberof ScriptState.ScriptVariables
         * @instance
         */
        ScriptVariables.prototype.gender = 0;

        /**
         * Unused (i.e. always 0) when used in `LevelInfo` (since the emulator is
         * expected to calculate that in real time), but should be set in a
         * solution's `LevelStateInfo`
         * @member {number} score
         * @memberof ScriptState.ScriptVariables
         * @instance
         */
        ScriptVariables.prototype.score = 0;

        /**
         * ScriptVariables keys.
         * @member {number} keys
         * @memberof ScriptState.ScriptVariables
         * @instance
         */
        ScriptVariables.prototype.keys = 0;

        /**
         * ScriptVariables level.
         * @member {number} level
         * @memberof ScriptState.ScriptVariables
         * @instance
         */
        ScriptVariables.prototype.level = 0;

        /**
         * ScriptVariables menu.
         * @member {number} menu
         * @memberof ScriptState.ScriptVariables
         * @instance
         */
        ScriptVariables.prototype.menu = 0;

        /**
         * ScriptVariables reg1.
         * @member {number} reg1
         * @memberof ScriptState.ScriptVariables
         * @instance
         */
        ScriptVariables.prototype.reg1 = 0;

        /**
         * ScriptVariables reg2.
         * @member {number} reg2
         * @memberof ScriptState.ScriptVariables
         * @instance
         */
        ScriptVariables.prototype.reg2 = 0;

        /**
         * ScriptVariables reg3.
         * @member {number} reg3
         * @memberof ScriptState.ScriptVariables
         * @instance
         */
        ScriptVariables.prototype.reg3 = 0;

        /**
         * ScriptVariables reg4.
         * @member {number} reg4
         * @memberof ScriptState.ScriptVariables
         * @instance
         */
        ScriptVariables.prototype.reg4 = 0;

        /**
         * ScriptVariables result.
         * @member {number} result
         * @memberof ScriptState.ScriptVariables
         * @instance
         */
        ScriptVariables.prototype.result = 0;

        /**
         * ScriptVariables speed.
         * @member {number} speed
         * @memberof ScriptState.ScriptVariables
         * @instance
         */
        ScriptVariables.prototype.speed = 0;

        /**
         * ScriptVariables tleft.
         * @member {number} tleft
         * @memberof ScriptState.ScriptVariables
         * @instance
         */
        ScriptVariables.prototype.tleft = 0;

        /**
         * ScriptVariables tools.
         * @member {number} tools
         * @memberof ScriptState.ScriptVariables
         * @instance
         */
        ScriptVariables.prototype.tools = 0;

        /**
         * Creates a new ScriptVariables instance using the specified properties.
         * @function create
         * @memberof ScriptState.ScriptVariables
         * @static
         * @param {ScriptState.IScriptVariables=} [properties] Properties to set
         * @returns {ScriptState.ScriptVariables} ScriptVariables instance
         */
        ScriptVariables.create = function create(properties) {
            return new ScriptVariables(properties);
        };

        /**
         * Encodes the specified ScriptVariables message. Does not implicitly {@link ScriptState.ScriptVariables.verify|verify} messages.
         * @function encode
         * @memberof ScriptState.ScriptVariables
         * @static
         * @param {ScriptState.IScriptVariables} message ScriptVariables message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ScriptVariables.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.enter != null && Object.hasOwnProperty.call(message, "enter"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.enter);
            if (message.exit != null && Object.hasOwnProperty.call(message, "exit"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.exit);
            if (message.flags != null && Object.hasOwnProperty.call(message, "flags"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.flags);
            if (message.gender != null && Object.hasOwnProperty.call(message, "gender"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.gender);
            if (message.score != null && Object.hasOwnProperty.call(message, "score"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.score);
            if (message.keys != null && Object.hasOwnProperty.call(message, "keys"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.keys);
            if (message.level != null && Object.hasOwnProperty.call(message, "level"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.level);
            if (message.menu != null && Object.hasOwnProperty.call(message, "menu"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.menu);
            if (message.reg1 != null && Object.hasOwnProperty.call(message, "reg1"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.reg1);
            if (message.reg2 != null && Object.hasOwnProperty.call(message, "reg2"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.reg2);
            if (message.reg3 != null && Object.hasOwnProperty.call(message, "reg3"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.reg3);
            if (message.reg4 != null && Object.hasOwnProperty.call(message, "reg4"))
                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.reg4);
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 14, wireType 0 =*/112).int32(message.result);
            if (message.speed != null && Object.hasOwnProperty.call(message, "speed"))
                writer.uint32(/* id 15, wireType 0 =*/120).int32(message.speed);
            if (message.tleft != null && Object.hasOwnProperty.call(message, "tleft"))
                writer.uint32(/* id 16, wireType 0 =*/128).int32(message.tleft);
            if (message.tools != null && Object.hasOwnProperty.call(message, "tools"))
                writer.uint32(/* id 17, wireType 0 =*/136).int32(message.tools);
            return writer;
        };

        /**
         * Encodes the specified ScriptVariables message, length delimited. Does not implicitly {@link ScriptState.ScriptVariables.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ScriptState.ScriptVariables
         * @static
         * @param {ScriptState.IScriptVariables} message ScriptVariables message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ScriptVariables.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ScriptVariables message from the specified reader or buffer.
         * @function decode
         * @memberof ScriptState.ScriptVariables
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ScriptState.ScriptVariables} ScriptVariables
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ScriptVariables.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ScriptState.ScriptVariables();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.enter = reader.int32();
                        break;
                    }
                case 2: {
                        message.exit = reader.int32();
                        break;
                    }
                case 3: {
                        message.flags = reader.int32();
                        break;
                    }
                case 4: {
                        message.gender = reader.int32();
                        break;
                    }
                case 5: {
                        message.score = reader.int32();
                        break;
                    }
                case 6: {
                        message.keys = reader.int32();
                        break;
                    }
                case 7: {
                        message.level = reader.int32();
                        break;
                    }
                case 9: {
                        message.menu = reader.int32();
                        break;
                    }
                case 10: {
                        message.reg1 = reader.int32();
                        break;
                    }
                case 11: {
                        message.reg2 = reader.int32();
                        break;
                    }
                case 12: {
                        message.reg3 = reader.int32();
                        break;
                    }
                case 13: {
                        message.reg4 = reader.int32();
                        break;
                    }
                case 14: {
                        message.result = reader.int32();
                        break;
                    }
                case 15: {
                        message.speed = reader.int32();
                        break;
                    }
                case 16: {
                        message.tleft = reader.int32();
                        break;
                    }
                case 17: {
                        message.tools = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ScriptVariables message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ScriptState.ScriptVariables
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ScriptState.ScriptVariables} ScriptVariables
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ScriptVariables.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ScriptVariables message.
         * @function verify
         * @memberof ScriptState.ScriptVariables
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ScriptVariables.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.enter != null && message.hasOwnProperty("enter"))
                if (!$util.isInteger(message.enter))
                    return "enter: integer expected";
            if (message.exit != null && message.hasOwnProperty("exit"))
                if (!$util.isInteger(message.exit))
                    return "exit: integer expected";
            if (message.flags != null && message.hasOwnProperty("flags"))
                if (!$util.isInteger(message.flags))
                    return "flags: integer expected";
            if (message.gender != null && message.hasOwnProperty("gender"))
                if (!$util.isInteger(message.gender))
                    return "gender: integer expected";
            if (message.score != null && message.hasOwnProperty("score"))
                if (!$util.isInteger(message.score))
                    return "score: integer expected";
            if (message.keys != null && message.hasOwnProperty("keys"))
                if (!$util.isInteger(message.keys))
                    return "keys: integer expected";
            if (message.level != null && message.hasOwnProperty("level"))
                if (!$util.isInteger(message.level))
                    return "level: integer expected";
            if (message.menu != null && message.hasOwnProperty("menu"))
                if (!$util.isInteger(message.menu))
                    return "menu: integer expected";
            if (message.reg1 != null && message.hasOwnProperty("reg1"))
                if (!$util.isInteger(message.reg1))
                    return "reg1: integer expected";
            if (message.reg2 != null && message.hasOwnProperty("reg2"))
                if (!$util.isInteger(message.reg2))
                    return "reg2: integer expected";
            if (message.reg3 != null && message.hasOwnProperty("reg3"))
                if (!$util.isInteger(message.reg3))
                    return "reg3: integer expected";
            if (message.reg4 != null && message.hasOwnProperty("reg4"))
                if (!$util.isInteger(message.reg4))
                    return "reg4: integer expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.speed != null && message.hasOwnProperty("speed"))
                if (!$util.isInteger(message.speed))
                    return "speed: integer expected";
            if (message.tleft != null && message.hasOwnProperty("tleft"))
                if (!$util.isInteger(message.tleft))
                    return "tleft: integer expected";
            if (message.tools != null && message.hasOwnProperty("tools"))
                if (!$util.isInteger(message.tools))
                    return "tools: integer expected";
            return null;
        };

        /**
         * Creates a ScriptVariables message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ScriptState.ScriptVariables
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ScriptState.ScriptVariables} ScriptVariables
         */
        ScriptVariables.fromObject = function fromObject(object) {
            if (object instanceof $root.ScriptState.ScriptVariables)
                return object;
            let message = new $root.ScriptState.ScriptVariables();
            if (object.enter != null)
                message.enter = object.enter | 0;
            if (object.exit != null)
                message.exit = object.exit | 0;
            if (object.flags != null)
                message.flags = object.flags | 0;
            if (object.gender != null)
                message.gender = object.gender | 0;
            if (object.score != null)
                message.score = object.score | 0;
            if (object.keys != null)
                message.keys = object.keys | 0;
            if (object.level != null)
                message.level = object.level | 0;
            if (object.menu != null)
                message.menu = object.menu | 0;
            if (object.reg1 != null)
                message.reg1 = object.reg1 | 0;
            if (object.reg2 != null)
                message.reg2 = object.reg2 | 0;
            if (object.reg3 != null)
                message.reg3 = object.reg3 | 0;
            if (object.reg4 != null)
                message.reg4 = object.reg4 | 0;
            if (object.result != null)
                message.result = object.result | 0;
            if (object.speed != null)
                message.speed = object.speed | 0;
            if (object.tleft != null)
                message.tleft = object.tleft | 0;
            if (object.tools != null)
                message.tools = object.tools | 0;
            return message;
        };

        /**
         * Creates a plain object from a ScriptVariables message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ScriptState.ScriptVariables
         * @static
         * @param {ScriptState.ScriptVariables} message ScriptVariables
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ScriptVariables.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.enter = 0;
                object.exit = 0;
                object.flags = 0;
                object.gender = 0;
                object.score = 0;
                object.keys = 0;
                object.level = 0;
                object.menu = 0;
                object.reg1 = 0;
                object.reg2 = 0;
                object.reg3 = 0;
                object.reg4 = 0;
                object.result = 0;
                object.speed = 0;
                object.tleft = 0;
                object.tools = 0;
            }
            if (message.enter != null && message.hasOwnProperty("enter"))
                object.enter = message.enter;
            if (message.exit != null && message.hasOwnProperty("exit"))
                object.exit = message.exit;
            if (message.flags != null && message.hasOwnProperty("flags"))
                object.flags = message.flags;
            if (message.gender != null && message.hasOwnProperty("gender"))
                object.gender = message.gender;
            if (message.score != null && message.hasOwnProperty("score"))
                object.score = message.score;
            if (message.keys != null && message.hasOwnProperty("keys"))
                object.keys = message.keys;
            if (message.level != null && message.hasOwnProperty("level"))
                object.level = message.level;
            if (message.menu != null && message.hasOwnProperty("menu"))
                object.menu = message.menu;
            if (message.reg1 != null && message.hasOwnProperty("reg1"))
                object.reg1 = message.reg1;
            if (message.reg2 != null && message.hasOwnProperty("reg2"))
                object.reg2 = message.reg2;
            if (message.reg3 != null && message.hasOwnProperty("reg3"))
                object.reg3 = message.reg3;
            if (message.reg4 != null && message.hasOwnProperty("reg4"))
                object.reg4 = message.reg4;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.speed != null && message.hasOwnProperty("speed"))
                object.speed = message.speed;
            if (message.tleft != null && message.hasOwnProperty("tleft"))
                object.tleft = message.tleft;
            if (message.tools != null && message.hasOwnProperty("tools"))
                object.tools = message.tools;
            return object;
        };

        /**
         * Converts this ScriptVariables to JSON.
         * @function toJSON
         * @memberof ScriptState.ScriptVariables
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ScriptVariables.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ScriptVariables
         * @function getTypeUrl
         * @memberof ScriptState.ScriptVariables
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ScriptVariables.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/ScriptState.ScriptVariables";
        };

        return ScriptVariables;
    })();

    return ScriptState;
})();

export const AttemptInfo = $root.AttemptInfo = (() => {

    /**
     * Properties of an AttemptInfo.
     * @exports IAttemptInfo
     * @interface IAttemptInfo
     * @property {google.protobuf.ITimestamp|null} [attemptStart] AttemptInfo attemptStart
     * @property {google.protobuf.IDuration|null} [attemptLength] AttemptInfo attemptLength
     * @property {string|null} [failReason] AttemptInfo failReason
     * @property {ISolutionInfo|null} [solution] AttemptInfo solution
     */

    /**
     * Constructs a new AttemptInfo.
     * @exports AttemptInfo
     * @classdesc Represents an AttemptInfo.
     * @implements IAttemptInfo
     * @constructor
     * @param {IAttemptInfo=} [properties] Properties to set
     */
    function AttemptInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AttemptInfo attemptStart.
     * @member {google.protobuf.ITimestamp|null|undefined} attemptStart
     * @memberof AttemptInfo
     * @instance
     */
    AttemptInfo.prototype.attemptStart = null;

    /**
     * AttemptInfo attemptLength.
     * @member {google.protobuf.IDuration|null|undefined} attemptLength
     * @memberof AttemptInfo
     * @instance
     */
    AttemptInfo.prototype.attemptLength = null;

    /**
     * AttemptInfo failReason.
     * @member {string|null|undefined} failReason
     * @memberof AttemptInfo
     * @instance
     */
    AttemptInfo.prototype.failReason = null;

    /**
     * AttemptInfo solution.
     * @member {ISolutionInfo|null|undefined} solution
     * @memberof AttemptInfo
     * @instance
     */
    AttemptInfo.prototype.solution = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * AttemptInfo attemptResult.
     * @member {"failReason"|"solution"|undefined} attemptResult
     * @memberof AttemptInfo
     * @instance
     */
    Object.defineProperty(AttemptInfo.prototype, "attemptResult", {
        get: $util.oneOfGetter($oneOfFields = ["failReason", "solution"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new AttemptInfo instance using the specified properties.
     * @function create
     * @memberof AttemptInfo
     * @static
     * @param {IAttemptInfo=} [properties] Properties to set
     * @returns {AttemptInfo} AttemptInfo instance
     */
    AttemptInfo.create = function create(properties) {
        return new AttemptInfo(properties);
    };

    /**
     * Encodes the specified AttemptInfo message. Does not implicitly {@link AttemptInfo.verify|verify} messages.
     * @function encode
     * @memberof AttemptInfo
     * @static
     * @param {IAttemptInfo} message AttemptInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AttemptInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.attemptStart != null && Object.hasOwnProperty.call(message, "attemptStart"))
            $root.google.protobuf.Timestamp.encode(message.attemptStart, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.attemptLength != null && Object.hasOwnProperty.call(message, "attemptLength"))
            $root.google.protobuf.Duration.encode(message.attemptLength, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.failReason != null && Object.hasOwnProperty.call(message, "failReason"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.failReason);
        if (message.solution != null && Object.hasOwnProperty.call(message, "solution"))
            $root.SolutionInfo.encode(message.solution, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified AttemptInfo message, length delimited. Does not implicitly {@link AttemptInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AttemptInfo
     * @static
     * @param {IAttemptInfo} message AttemptInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AttemptInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AttemptInfo message from the specified reader or buffer.
     * @function decode
     * @memberof AttemptInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AttemptInfo} AttemptInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AttemptInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AttemptInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.attemptStart = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                    break;
                }
            case 2: {
                    message.attemptLength = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.failReason = reader.string();
                    break;
                }
            case 4: {
                    message.solution = $root.SolutionInfo.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AttemptInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AttemptInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AttemptInfo} AttemptInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AttemptInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AttemptInfo message.
     * @function verify
     * @memberof AttemptInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AttemptInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        let properties = {};
        if (message.attemptStart != null && message.hasOwnProperty("attemptStart")) {
            let error = $root.google.protobuf.Timestamp.verify(message.attemptStart);
            if (error)
                return "attemptStart." + error;
        }
        if (message.attemptLength != null && message.hasOwnProperty("attemptLength")) {
            let error = $root.google.protobuf.Duration.verify(message.attemptLength);
            if (error)
                return "attemptLength." + error;
        }
        if (message.failReason != null && message.hasOwnProperty("failReason")) {
            properties.attemptResult = 1;
            if (!$util.isString(message.failReason))
                return "failReason: string expected";
        }
        if (message.solution != null && message.hasOwnProperty("solution")) {
            if (properties.attemptResult === 1)
                return "attemptResult: multiple values";
            properties.attemptResult = 1;
            {
                let error = $root.SolutionInfo.verify(message.solution);
                if (error)
                    return "solution." + error;
            }
        }
        return null;
    };

    /**
     * Creates an AttemptInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AttemptInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AttemptInfo} AttemptInfo
     */
    AttemptInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.AttemptInfo)
            return object;
        let message = new $root.AttemptInfo();
        if (object.attemptStart != null) {
            if (typeof object.attemptStart !== "object")
                throw TypeError(".AttemptInfo.attemptStart: object expected");
            message.attemptStart = $root.google.protobuf.Timestamp.fromObject(object.attemptStart);
        }
        if (object.attemptLength != null) {
            if (typeof object.attemptLength !== "object")
                throw TypeError(".AttemptInfo.attemptLength: object expected");
            message.attemptLength = $root.google.protobuf.Duration.fromObject(object.attemptLength);
        }
        if (object.failReason != null)
            message.failReason = String(object.failReason);
        if (object.solution != null) {
            if (typeof object.solution !== "object")
                throw TypeError(".AttemptInfo.solution: object expected");
            message.solution = $root.SolutionInfo.fromObject(object.solution);
        }
        return message;
    };

    /**
     * Creates a plain object from an AttemptInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AttemptInfo
     * @static
     * @param {AttemptInfo} message AttemptInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AttemptInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.attemptStart = null;
            object.attemptLength = null;
        }
        if (message.attemptStart != null && message.hasOwnProperty("attemptStart"))
            object.attemptStart = $root.google.protobuf.Timestamp.toObject(message.attemptStart, options);
        if (message.attemptLength != null && message.hasOwnProperty("attemptLength"))
            object.attemptLength = $root.google.protobuf.Duration.toObject(message.attemptLength, options);
        if (message.failReason != null && message.hasOwnProperty("failReason")) {
            object.failReason = message.failReason;
            if (options.oneofs)
                object.attemptResult = "failReason";
        }
        if (message.solution != null && message.hasOwnProperty("solution")) {
            object.solution = $root.SolutionInfo.toObject(message.solution, options);
            if (options.oneofs)
                object.attemptResult = "solution";
        }
        return object;
    };

    /**
     * Converts this AttemptInfo to JSON.
     * @function toJSON
     * @memberof AttemptInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AttemptInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AttemptInfo
     * @function getTypeUrl
     * @memberof AttemptInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AttemptInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AttemptInfo";
    };

    return AttemptInfo;
})();

export const SolutionInfo = $root.SolutionInfo = (() => {

    /**
     * Properties of a SolutionInfo.
     * @exports ISolutionInfo
     * @interface ISolutionInfo
     * @property {Array.<Uint8Array>|null} [steps] SolutionInfo steps
     * @property {ILevelStateInfo|null} [levelState] SolutionInfo levelState
     * @property {ISolutionOutcomeInfo|null} [outcome] SolutionInfo outcome
     * @property {number|null} [solutionN] SolutionInfo solutionN
     * @property {string|null} [solutionComment] SolutionInfo solutionComment
     * @property {Array.<IGlitchInfo>|null} [usedGlitches] SolutionInfo usedGlitches
     */

    /**
     * Constructs a new SolutionInfo.
     * @exports SolutionInfo
     * @classdesc Represents a SolutionInfo.
     * @implements ISolutionInfo
     * @constructor
     * @param {ISolutionInfo=} [properties] Properties to set
     */
    function SolutionInfo(properties) {
        this.steps = [];
        this.usedGlitches = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SolutionInfo steps.
     * @member {Array.<Uint8Array>} steps
     * @memberof SolutionInfo
     * @instance
     */
    SolutionInfo.prototype.steps = $util.emptyArray;

    /**
     * SolutionInfo levelState.
     * @member {ILevelStateInfo|null|undefined} levelState
     * @memberof SolutionInfo
     * @instance
     */
    SolutionInfo.prototype.levelState = null;

    /**
     * SolutionInfo outcome.
     * @member {ISolutionOutcomeInfo|null|undefined} outcome
     * @memberof SolutionInfo
     * @instance
     */
    SolutionInfo.prototype.outcome = null;

    /**
     * SolutionInfo solutionN.
     * @member {number} solutionN
     * @memberof SolutionInfo
     * @instance
     */
    SolutionInfo.prototype.solutionN = 0;

    /**
     * SolutionInfo solutionComment.
     * @member {string} solutionComment
     * @memberof SolutionInfo
     * @instance
     */
    SolutionInfo.prototype.solutionComment = "";

    /**
     * SolutionInfo usedGlitches.
     * @member {Array.<IGlitchInfo>} usedGlitches
     * @memberof SolutionInfo
     * @instance
     */
    SolutionInfo.prototype.usedGlitches = $util.emptyArray;

    /**
     * Creates a new SolutionInfo instance using the specified properties.
     * @function create
     * @memberof SolutionInfo
     * @static
     * @param {ISolutionInfo=} [properties] Properties to set
     * @returns {SolutionInfo} SolutionInfo instance
     */
    SolutionInfo.create = function create(properties) {
        return new SolutionInfo(properties);
    };

    /**
     * Encodes the specified SolutionInfo message. Does not implicitly {@link SolutionInfo.verify|verify} messages.
     * @function encode
     * @memberof SolutionInfo
     * @static
     * @param {ISolutionInfo} message SolutionInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SolutionInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.steps != null && message.steps.length)
            for (let i = 0; i < message.steps.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.steps[i]);
        if (message.levelState != null && Object.hasOwnProperty.call(message, "levelState"))
            $root.LevelStateInfo.encode(message.levelState, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.outcome != null && Object.hasOwnProperty.call(message, "outcome"))
            $root.SolutionOutcomeInfo.encode(message.outcome, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.solutionN != null && Object.hasOwnProperty.call(message, "solutionN"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.solutionN);
        if (message.solutionComment != null && Object.hasOwnProperty.call(message, "solutionComment"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.solutionComment);
        if (message.usedGlitches != null && message.usedGlitches.length)
            for (let i = 0; i < message.usedGlitches.length; ++i)
                $root.GlitchInfo.encode(message.usedGlitches[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified SolutionInfo message, length delimited. Does not implicitly {@link SolutionInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SolutionInfo
     * @static
     * @param {ISolutionInfo} message SolutionInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SolutionInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SolutionInfo message from the specified reader or buffer.
     * @function decode
     * @memberof SolutionInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SolutionInfo} SolutionInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SolutionInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SolutionInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.steps && message.steps.length))
                        message.steps = [];
                    message.steps.push(reader.bytes());
                    break;
                }
            case 2: {
                    message.levelState = $root.LevelStateInfo.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.outcome = $root.SolutionOutcomeInfo.decode(reader, reader.uint32());
                    break;
                }
            case 4: {
                    message.solutionN = reader.int32();
                    break;
                }
            case 5: {
                    message.solutionComment = reader.string();
                    break;
                }
            case 6: {
                    if (!(message.usedGlitches && message.usedGlitches.length))
                        message.usedGlitches = [];
                    message.usedGlitches.push($root.GlitchInfo.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SolutionInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SolutionInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SolutionInfo} SolutionInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SolutionInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SolutionInfo message.
     * @function verify
     * @memberof SolutionInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SolutionInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.steps != null && message.hasOwnProperty("steps")) {
            if (!Array.isArray(message.steps))
                return "steps: array expected";
            for (let i = 0; i < message.steps.length; ++i)
                if (!(message.steps[i] && typeof message.steps[i].length === "number" || $util.isString(message.steps[i])))
                    return "steps: buffer[] expected";
        }
        if (message.levelState != null && message.hasOwnProperty("levelState")) {
            let error = $root.LevelStateInfo.verify(message.levelState);
            if (error)
                return "levelState." + error;
        }
        if (message.outcome != null && message.hasOwnProperty("outcome")) {
            let error = $root.SolutionOutcomeInfo.verify(message.outcome);
            if (error)
                return "outcome." + error;
        }
        if (message.solutionN != null && message.hasOwnProperty("solutionN"))
            if (!$util.isInteger(message.solutionN))
                return "solutionN: integer expected";
        if (message.solutionComment != null && message.hasOwnProperty("solutionComment"))
            if (!$util.isString(message.solutionComment))
                return "solutionComment: string expected";
        if (message.usedGlitches != null && message.hasOwnProperty("usedGlitches")) {
            if (!Array.isArray(message.usedGlitches))
                return "usedGlitches: array expected";
            for (let i = 0; i < message.usedGlitches.length; ++i) {
                let error = $root.GlitchInfo.verify(message.usedGlitches[i]);
                if (error)
                    return "usedGlitches." + error;
            }
        }
        return null;
    };

    /**
     * Creates a SolutionInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SolutionInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SolutionInfo} SolutionInfo
     */
    SolutionInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.SolutionInfo)
            return object;
        let message = new $root.SolutionInfo();
        if (object.steps) {
            if (!Array.isArray(object.steps))
                throw TypeError(".SolutionInfo.steps: array expected");
            message.steps = [];
            for (let i = 0; i < object.steps.length; ++i)
                if (typeof object.steps[i] === "string")
                    $util.base64.decode(object.steps[i], message.steps[i] = $util.newBuffer($util.base64.length(object.steps[i])), 0);
                else if (object.steps[i].length >= 0)
                    message.steps[i] = object.steps[i];
        }
        if (object.levelState != null) {
            if (typeof object.levelState !== "object")
                throw TypeError(".SolutionInfo.levelState: object expected");
            message.levelState = $root.LevelStateInfo.fromObject(object.levelState);
        }
        if (object.outcome != null) {
            if (typeof object.outcome !== "object")
                throw TypeError(".SolutionInfo.outcome: object expected");
            message.outcome = $root.SolutionOutcomeInfo.fromObject(object.outcome);
        }
        if (object.solutionN != null)
            message.solutionN = object.solutionN | 0;
        if (object.solutionComment != null)
            message.solutionComment = String(object.solutionComment);
        if (object.usedGlitches) {
            if (!Array.isArray(object.usedGlitches))
                throw TypeError(".SolutionInfo.usedGlitches: array expected");
            message.usedGlitches = [];
            for (let i = 0; i < object.usedGlitches.length; ++i) {
                if (typeof object.usedGlitches[i] !== "object")
                    throw TypeError(".SolutionInfo.usedGlitches: object expected");
                message.usedGlitches[i] = $root.GlitchInfo.fromObject(object.usedGlitches[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a SolutionInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SolutionInfo
     * @static
     * @param {SolutionInfo} message SolutionInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SolutionInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.steps = [];
            object.usedGlitches = [];
        }
        if (options.defaults) {
            object.levelState = null;
            object.outcome = null;
            object.solutionN = 0;
            object.solutionComment = "";
        }
        if (message.steps && message.steps.length) {
            object.steps = [];
            for (let j = 0; j < message.steps.length; ++j)
                object.steps[j] = options.bytes === String ? $util.base64.encode(message.steps[j], 0, message.steps[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.steps[j]) : message.steps[j];
        }
        if (message.levelState != null && message.hasOwnProperty("levelState"))
            object.levelState = $root.LevelStateInfo.toObject(message.levelState, options);
        if (message.outcome != null && message.hasOwnProperty("outcome"))
            object.outcome = $root.SolutionOutcomeInfo.toObject(message.outcome, options);
        if (message.solutionN != null && message.hasOwnProperty("solutionN"))
            object.solutionN = message.solutionN;
        if (message.solutionComment != null && message.hasOwnProperty("solutionComment"))
            object.solutionComment = message.solutionComment;
        if (message.usedGlitches && message.usedGlitches.length) {
            object.usedGlitches = [];
            for (let j = 0; j < message.usedGlitches.length; ++j)
                object.usedGlitches[j] = $root.GlitchInfo.toObject(message.usedGlitches[j], options);
        }
        return object;
    };

    /**
     * Converts this SolutionInfo to JSON.
     * @function toJSON
     * @memberof SolutionInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SolutionInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for SolutionInfo
     * @function getTypeUrl
     * @memberof SolutionInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    SolutionInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/SolutionInfo";
    };

    return SolutionInfo;
})();

export const SolutionOutcomeInfo = $root.SolutionOutcomeInfo = (() => {

    /**
     * Properties of a SolutionOutcomeInfo.
     * @exports ISolutionOutcomeInfo
     * @interface ISolutionOutcomeInfo
     * @property {google.protobuf.IDuration|null} [timeLeft] SolutionOutcomeInfo timeLeft
     * @property {google.protobuf.IDuration|null} [absoluteTime] SolutionOutcomeInfo absoluteTime
     * @property {number|null} [bonusScore] SolutionOutcomeInfo bonusScore
     */

    /**
     * Constructs a new SolutionOutcomeInfo.
     * @exports SolutionOutcomeInfo
     * @classdesc Represents a SolutionOutcomeInfo.
     * @implements ISolutionOutcomeInfo
     * @constructor
     * @param {ISolutionOutcomeInfo=} [properties] Properties to set
     */
    function SolutionOutcomeInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SolutionOutcomeInfo timeLeft.
     * @member {google.protobuf.IDuration|null|undefined} timeLeft
     * @memberof SolutionOutcomeInfo
     * @instance
     */
    SolutionOutcomeInfo.prototype.timeLeft = null;

    /**
     * SolutionOutcomeInfo absoluteTime.
     * @member {google.protobuf.IDuration|null|undefined} absoluteTime
     * @memberof SolutionOutcomeInfo
     * @instance
     */
    SolutionOutcomeInfo.prototype.absoluteTime = null;

    /**
     * SolutionOutcomeInfo bonusScore.
     * @member {number} bonusScore
     * @memberof SolutionOutcomeInfo
     * @instance
     */
    SolutionOutcomeInfo.prototype.bonusScore = 0;

    /**
     * Creates a new SolutionOutcomeInfo instance using the specified properties.
     * @function create
     * @memberof SolutionOutcomeInfo
     * @static
     * @param {ISolutionOutcomeInfo=} [properties] Properties to set
     * @returns {SolutionOutcomeInfo} SolutionOutcomeInfo instance
     */
    SolutionOutcomeInfo.create = function create(properties) {
        return new SolutionOutcomeInfo(properties);
    };

    /**
     * Encodes the specified SolutionOutcomeInfo message. Does not implicitly {@link SolutionOutcomeInfo.verify|verify} messages.
     * @function encode
     * @memberof SolutionOutcomeInfo
     * @static
     * @param {ISolutionOutcomeInfo} message SolutionOutcomeInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SolutionOutcomeInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.timeLeft != null && Object.hasOwnProperty.call(message, "timeLeft"))
            $root.google.protobuf.Duration.encode(message.timeLeft, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.absoluteTime != null && Object.hasOwnProperty.call(message, "absoluteTime"))
            $root.google.protobuf.Duration.encode(message.absoluteTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.bonusScore != null && Object.hasOwnProperty.call(message, "bonusScore"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.bonusScore);
        return writer;
    };

    /**
     * Encodes the specified SolutionOutcomeInfo message, length delimited. Does not implicitly {@link SolutionOutcomeInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SolutionOutcomeInfo
     * @static
     * @param {ISolutionOutcomeInfo} message SolutionOutcomeInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SolutionOutcomeInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SolutionOutcomeInfo message from the specified reader or buffer.
     * @function decode
     * @memberof SolutionOutcomeInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SolutionOutcomeInfo} SolutionOutcomeInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SolutionOutcomeInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SolutionOutcomeInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.timeLeft = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                    break;
                }
            case 2: {
                    message.absoluteTime = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.bonusScore = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SolutionOutcomeInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SolutionOutcomeInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SolutionOutcomeInfo} SolutionOutcomeInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SolutionOutcomeInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SolutionOutcomeInfo message.
     * @function verify
     * @memberof SolutionOutcomeInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SolutionOutcomeInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.timeLeft != null && message.hasOwnProperty("timeLeft")) {
            let error = $root.google.protobuf.Duration.verify(message.timeLeft);
            if (error)
                return "timeLeft." + error;
        }
        if (message.absoluteTime != null && message.hasOwnProperty("absoluteTime")) {
            let error = $root.google.protobuf.Duration.verify(message.absoluteTime);
            if (error)
                return "absoluteTime." + error;
        }
        if (message.bonusScore != null && message.hasOwnProperty("bonusScore"))
            if (!$util.isInteger(message.bonusScore))
                return "bonusScore: integer expected";
        return null;
    };

    /**
     * Creates a SolutionOutcomeInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SolutionOutcomeInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SolutionOutcomeInfo} SolutionOutcomeInfo
     */
    SolutionOutcomeInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.SolutionOutcomeInfo)
            return object;
        let message = new $root.SolutionOutcomeInfo();
        if (object.timeLeft != null) {
            if (typeof object.timeLeft !== "object")
                throw TypeError(".SolutionOutcomeInfo.timeLeft: object expected");
            message.timeLeft = $root.google.protobuf.Duration.fromObject(object.timeLeft);
        }
        if (object.absoluteTime != null) {
            if (typeof object.absoluteTime !== "object")
                throw TypeError(".SolutionOutcomeInfo.absoluteTime: object expected");
            message.absoluteTime = $root.google.protobuf.Duration.fromObject(object.absoluteTime);
        }
        if (object.bonusScore != null)
            message.bonusScore = object.bonusScore >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a SolutionOutcomeInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SolutionOutcomeInfo
     * @static
     * @param {SolutionOutcomeInfo} message SolutionOutcomeInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SolutionOutcomeInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.timeLeft = null;
            object.absoluteTime = null;
            object.bonusScore = 0;
        }
        if (message.timeLeft != null && message.hasOwnProperty("timeLeft"))
            object.timeLeft = $root.google.protobuf.Duration.toObject(message.timeLeft, options);
        if (message.absoluteTime != null && message.hasOwnProperty("absoluteTime"))
            object.absoluteTime = $root.google.protobuf.Duration.toObject(message.absoluteTime, options);
        if (message.bonusScore != null && message.hasOwnProperty("bonusScore"))
            object.bonusScore = message.bonusScore;
        return object;
    };

    /**
     * Converts this SolutionOutcomeInfo to JSON.
     * @function toJSON
     * @memberof SolutionOutcomeInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SolutionOutcomeInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for SolutionOutcomeInfo
     * @function getTypeUrl
     * @memberof SolutionOutcomeInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    SolutionOutcomeInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/SolutionOutcomeInfo";
    };

    return SolutionOutcomeInfo;
})();

export const LevelStateInfo = $root.LevelStateInfo = (() => {

    /**
     * Properties of a LevelStateInfo.
     * @exports ILevelStateInfo
     * @interface ILevelStateInfo
     * @property {ProtoDirection|null} [randomForceFloorDirection] LevelStateInfo randomForceFloorDirection
     * @property {LevelStateInfo.ICC1LevelStateData|null} [cc1Data] LevelStateInfo cc1Data
     * @property {LevelStateInfo.ICC2LevelStateData|null} [cc2Data] LevelStateInfo cc2Data
     */

    /**
     * Constructs a new LevelStateInfo.
     * @exports LevelStateInfo
     * @classdesc Represents a LevelStateInfo.
     * @implements ILevelStateInfo
     * @constructor
     * @param {ILevelStateInfo=} [properties] Properties to set
     */
    function LevelStateInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * LevelStateInfo randomForceFloorDirection.
     * @member {ProtoDirection} randomForceFloorDirection
     * @memberof LevelStateInfo
     * @instance
     */
    LevelStateInfo.prototype.randomForceFloorDirection = 0;

    /**
     * LevelStateInfo cc1Data.
     * @member {LevelStateInfo.ICC1LevelStateData|null|undefined} cc1Data
     * @memberof LevelStateInfo
     * @instance
     */
    LevelStateInfo.prototype.cc1Data = null;

    /**
     * LevelStateInfo cc2Data.
     * @member {LevelStateInfo.ICC2LevelStateData|null|undefined} cc2Data
     * @memberof LevelStateInfo
     * @instance
     */
    LevelStateInfo.prototype.cc2Data = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * LevelStateInfo customLevelState.
     * @member {"cc1Data"|"cc2Data"|undefined} customLevelState
     * @memberof LevelStateInfo
     * @instance
     */
    Object.defineProperty(LevelStateInfo.prototype, "customLevelState", {
        get: $util.oneOfGetter($oneOfFields = ["cc1Data", "cc2Data"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new LevelStateInfo instance using the specified properties.
     * @function create
     * @memberof LevelStateInfo
     * @static
     * @param {ILevelStateInfo=} [properties] Properties to set
     * @returns {LevelStateInfo} LevelStateInfo instance
     */
    LevelStateInfo.create = function create(properties) {
        return new LevelStateInfo(properties);
    };

    /**
     * Encodes the specified LevelStateInfo message. Does not implicitly {@link LevelStateInfo.verify|verify} messages.
     * @function encode
     * @memberof LevelStateInfo
     * @static
     * @param {ILevelStateInfo} message LevelStateInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LevelStateInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.randomForceFloorDirection != null && Object.hasOwnProperty.call(message, "randomForceFloorDirection"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.randomForceFloorDirection);
        if (message.cc1Data != null && Object.hasOwnProperty.call(message, "cc1Data"))
            $root.LevelStateInfo.CC1LevelStateData.encode(message.cc1Data, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.cc2Data != null && Object.hasOwnProperty.call(message, "cc2Data"))
            $root.LevelStateInfo.CC2LevelStateData.encode(message.cc2Data, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified LevelStateInfo message, length delimited. Does not implicitly {@link LevelStateInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LevelStateInfo
     * @static
     * @param {ILevelStateInfo} message LevelStateInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LevelStateInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a LevelStateInfo message from the specified reader or buffer.
     * @function decode
     * @memberof LevelStateInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LevelStateInfo} LevelStateInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LevelStateInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.LevelStateInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.randomForceFloorDirection = reader.int32();
                    break;
                }
            case 2: {
                    message.cc1Data = $root.LevelStateInfo.CC1LevelStateData.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.cc2Data = $root.LevelStateInfo.CC2LevelStateData.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a LevelStateInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LevelStateInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LevelStateInfo} LevelStateInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LevelStateInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a LevelStateInfo message.
     * @function verify
     * @memberof LevelStateInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    LevelStateInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        let properties = {};
        if (message.randomForceFloorDirection != null && message.hasOwnProperty("randomForceFloorDirection"))
            switch (message.randomForceFloorDirection) {
            default:
                return "randomForceFloorDirection: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        if (message.cc1Data != null && message.hasOwnProperty("cc1Data")) {
            properties.customLevelState = 1;
            {
                let error = $root.LevelStateInfo.CC1LevelStateData.verify(message.cc1Data);
                if (error)
                    return "cc1Data." + error;
            }
        }
        if (message.cc2Data != null && message.hasOwnProperty("cc2Data")) {
            if (properties.customLevelState === 1)
                return "customLevelState: multiple values";
            properties.customLevelState = 1;
            {
                let error = $root.LevelStateInfo.CC2LevelStateData.verify(message.cc2Data);
                if (error)
                    return "cc2Data." + error;
            }
        }
        return null;
    };

    /**
     * Creates a LevelStateInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LevelStateInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LevelStateInfo} LevelStateInfo
     */
    LevelStateInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.LevelStateInfo)
            return object;
        let message = new $root.LevelStateInfo();
        switch (object.randomForceFloorDirection) {
        default:
            if (typeof object.randomForceFloorDirection === "number") {
                message.randomForceFloorDirection = object.randomForceFloorDirection;
                break;
            }
            break;
        case "INVALID":
        case 0:
            message.randomForceFloorDirection = 0;
            break;
        case "UP":
        case 1:
            message.randomForceFloorDirection = 1;
            break;
        case "RIGHT":
        case 2:
            message.randomForceFloorDirection = 2;
            break;
        case "DOWN":
        case 3:
            message.randomForceFloorDirection = 3;
            break;
        case "LEFT":
        case 4:
            message.randomForceFloorDirection = 4;
            break;
        }
        if (object.cc1Data != null) {
            if (typeof object.cc1Data !== "object")
                throw TypeError(".LevelStateInfo.cc1Data: object expected");
            message.cc1Data = $root.LevelStateInfo.CC1LevelStateData.fromObject(object.cc1Data);
        }
        if (object.cc2Data != null) {
            if (typeof object.cc2Data !== "object")
                throw TypeError(".LevelStateInfo.cc2Data: object expected");
            message.cc2Data = $root.LevelStateInfo.CC2LevelStateData.fromObject(object.cc2Data);
        }
        return message;
    };

    /**
     * Creates a plain object from a LevelStateInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LevelStateInfo
     * @static
     * @param {LevelStateInfo} message LevelStateInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LevelStateInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.randomForceFloorDirection = options.enums === String ? "INVALID" : 0;
        if (message.randomForceFloorDirection != null && message.hasOwnProperty("randomForceFloorDirection"))
            object.randomForceFloorDirection = options.enums === String ? $root.ProtoDirection[message.randomForceFloorDirection] === undefined ? message.randomForceFloorDirection : $root.ProtoDirection[message.randomForceFloorDirection] : message.randomForceFloorDirection;
        if (message.cc1Data != null && message.hasOwnProperty("cc1Data")) {
            object.cc1Data = $root.LevelStateInfo.CC1LevelStateData.toObject(message.cc1Data, options);
            if (options.oneofs)
                object.customLevelState = "cc1Data";
        }
        if (message.cc2Data != null && message.hasOwnProperty("cc2Data")) {
            object.cc2Data = $root.LevelStateInfo.CC2LevelStateData.toObject(message.cc2Data, options);
            if (options.oneofs)
                object.customLevelState = "cc2Data";
        }
        return object;
    };

    /**
     * Converts this LevelStateInfo to JSON.
     * @function toJSON
     * @memberof LevelStateInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LevelStateInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for LevelStateInfo
     * @function getTypeUrl
     * @memberof LevelStateInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    LevelStateInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/LevelStateInfo";
    };

    LevelStateInfo.CC1LevelStateData = (function() {

        /**
         * Properties of a CC1LevelStateData.
         * @memberof LevelStateInfo
         * @interface ICC1LevelStateData
         * @property {number|null} [randomnessSeed] CC1LevelStateData randomnessSeed
         * @property {number|null} [stepParity] CC1LevelStateData stepParity
         */

        /**
         * Constructs a new CC1LevelStateData.
         * @memberof LevelStateInfo
         * @classdesc Represents a CC1LevelStateData.
         * @implements ICC1LevelStateData
         * @constructor
         * @param {LevelStateInfo.ICC1LevelStateData=} [properties] Properties to set
         */
        function CC1LevelStateData(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CC1LevelStateData randomnessSeed.
         * @member {number} randomnessSeed
         * @memberof LevelStateInfo.CC1LevelStateData
         * @instance
         */
        CC1LevelStateData.prototype.randomnessSeed = 0;

        /**
         * CC1LevelStateData stepParity.
         * @member {number} stepParity
         * @memberof LevelStateInfo.CC1LevelStateData
         * @instance
         */
        CC1LevelStateData.prototype.stepParity = 0;

        /**
         * Creates a new CC1LevelStateData instance using the specified properties.
         * @function create
         * @memberof LevelStateInfo.CC1LevelStateData
         * @static
         * @param {LevelStateInfo.ICC1LevelStateData=} [properties] Properties to set
         * @returns {LevelStateInfo.CC1LevelStateData} CC1LevelStateData instance
         */
        CC1LevelStateData.create = function create(properties) {
            return new CC1LevelStateData(properties);
        };

        /**
         * Encodes the specified CC1LevelStateData message. Does not implicitly {@link LevelStateInfo.CC1LevelStateData.verify|verify} messages.
         * @function encode
         * @memberof LevelStateInfo.CC1LevelStateData
         * @static
         * @param {LevelStateInfo.ICC1LevelStateData} message CC1LevelStateData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CC1LevelStateData.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.randomnessSeed != null && Object.hasOwnProperty.call(message, "randomnessSeed"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.randomnessSeed);
            if (message.stepParity != null && Object.hasOwnProperty.call(message, "stepParity"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.stepParity);
            return writer;
        };

        /**
         * Encodes the specified CC1LevelStateData message, length delimited. Does not implicitly {@link LevelStateInfo.CC1LevelStateData.verify|verify} messages.
         * @function encodeDelimited
         * @memberof LevelStateInfo.CC1LevelStateData
         * @static
         * @param {LevelStateInfo.ICC1LevelStateData} message CC1LevelStateData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CC1LevelStateData.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CC1LevelStateData message from the specified reader or buffer.
         * @function decode
         * @memberof LevelStateInfo.CC1LevelStateData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {LevelStateInfo.CC1LevelStateData} CC1LevelStateData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CC1LevelStateData.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.LevelStateInfo.CC1LevelStateData();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.randomnessSeed = reader.int32();
                        break;
                    }
                case 2: {
                        message.stepParity = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CC1LevelStateData message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof LevelStateInfo.CC1LevelStateData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {LevelStateInfo.CC1LevelStateData} CC1LevelStateData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CC1LevelStateData.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CC1LevelStateData message.
         * @function verify
         * @memberof LevelStateInfo.CC1LevelStateData
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CC1LevelStateData.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.randomnessSeed != null && message.hasOwnProperty("randomnessSeed"))
                if (!$util.isInteger(message.randomnessSeed))
                    return "randomnessSeed: integer expected";
            if (message.stepParity != null && message.hasOwnProperty("stepParity"))
                if (!$util.isInteger(message.stepParity))
                    return "stepParity: integer expected";
            return null;
        };

        /**
         * Creates a CC1LevelStateData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof LevelStateInfo.CC1LevelStateData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {LevelStateInfo.CC1LevelStateData} CC1LevelStateData
         */
        CC1LevelStateData.fromObject = function fromObject(object) {
            if (object instanceof $root.LevelStateInfo.CC1LevelStateData)
                return object;
            let message = new $root.LevelStateInfo.CC1LevelStateData();
            if (object.randomnessSeed != null)
                message.randomnessSeed = object.randomnessSeed | 0;
            if (object.stepParity != null)
                message.stepParity = object.stepParity | 0;
            return message;
        };

        /**
         * Creates a plain object from a CC1LevelStateData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof LevelStateInfo.CC1LevelStateData
         * @static
         * @param {LevelStateInfo.CC1LevelStateData} message CC1LevelStateData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CC1LevelStateData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.randomnessSeed = 0;
                object.stepParity = 0;
            }
            if (message.randomnessSeed != null && message.hasOwnProperty("randomnessSeed"))
                object.randomnessSeed = message.randomnessSeed;
            if (message.stepParity != null && message.hasOwnProperty("stepParity"))
                object.stepParity = message.stepParity;
            return object;
        };

        /**
         * Converts this CC1LevelStateData to JSON.
         * @function toJSON
         * @memberof LevelStateInfo.CC1LevelStateData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CC1LevelStateData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CC1LevelStateData
         * @function getTypeUrl
         * @memberof LevelStateInfo.CC1LevelStateData
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CC1LevelStateData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/LevelStateInfo.CC1LevelStateData";
        };

        return CC1LevelStateData;
    })();

    LevelStateInfo.CC2LevelStateData = (function() {

        /**
         * Properties of a CC2LevelStateData.
         * @memberof LevelStateInfo
         * @interface ICC2LevelStateData
         * @property {number|null} [blobModifier] CC2LevelStateData blobModifier
         * @property {IScriptState|null} [scriptState] CC2LevelStateData scriptState
         */

        /**
         * Constructs a new CC2LevelStateData.
         * @memberof LevelStateInfo
         * @classdesc Represents a CC2LevelStateData.
         * @implements ICC2LevelStateData
         * @constructor
         * @param {LevelStateInfo.ICC2LevelStateData=} [properties] Properties to set
         */
        function CC2LevelStateData(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CC2LevelStateData blobModifier.
         * @member {number} blobModifier
         * @memberof LevelStateInfo.CC2LevelStateData
         * @instance
         */
        CC2LevelStateData.prototype.blobModifier = 0;

        /**
         * CC2LevelStateData scriptState.
         * @member {IScriptState|null|undefined} scriptState
         * @memberof LevelStateInfo.CC2LevelStateData
         * @instance
         */
        CC2LevelStateData.prototype.scriptState = null;

        /**
         * Creates a new CC2LevelStateData instance using the specified properties.
         * @function create
         * @memberof LevelStateInfo.CC2LevelStateData
         * @static
         * @param {LevelStateInfo.ICC2LevelStateData=} [properties] Properties to set
         * @returns {LevelStateInfo.CC2LevelStateData} CC2LevelStateData instance
         */
        CC2LevelStateData.create = function create(properties) {
            return new CC2LevelStateData(properties);
        };

        /**
         * Encodes the specified CC2LevelStateData message. Does not implicitly {@link LevelStateInfo.CC2LevelStateData.verify|verify} messages.
         * @function encode
         * @memberof LevelStateInfo.CC2LevelStateData
         * @static
         * @param {LevelStateInfo.ICC2LevelStateData} message CC2LevelStateData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CC2LevelStateData.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.blobModifier != null && Object.hasOwnProperty.call(message, "blobModifier"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.blobModifier);
            if (message.scriptState != null && Object.hasOwnProperty.call(message, "scriptState"))
                $root.ScriptState.encode(message.scriptState, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CC2LevelStateData message, length delimited. Does not implicitly {@link LevelStateInfo.CC2LevelStateData.verify|verify} messages.
         * @function encodeDelimited
         * @memberof LevelStateInfo.CC2LevelStateData
         * @static
         * @param {LevelStateInfo.ICC2LevelStateData} message CC2LevelStateData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CC2LevelStateData.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CC2LevelStateData message from the specified reader or buffer.
         * @function decode
         * @memberof LevelStateInfo.CC2LevelStateData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {LevelStateInfo.CC2LevelStateData} CC2LevelStateData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CC2LevelStateData.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.LevelStateInfo.CC2LevelStateData();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.blobModifier = reader.int32();
                        break;
                    }
                case 2: {
                        message.scriptState = $root.ScriptState.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CC2LevelStateData message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof LevelStateInfo.CC2LevelStateData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {LevelStateInfo.CC2LevelStateData} CC2LevelStateData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CC2LevelStateData.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CC2LevelStateData message.
         * @function verify
         * @memberof LevelStateInfo.CC2LevelStateData
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CC2LevelStateData.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.blobModifier != null && message.hasOwnProperty("blobModifier"))
                if (!$util.isInteger(message.blobModifier))
                    return "blobModifier: integer expected";
            if (message.scriptState != null && message.hasOwnProperty("scriptState")) {
                let error = $root.ScriptState.verify(message.scriptState);
                if (error)
                    return "scriptState." + error;
            }
            return null;
        };

        /**
         * Creates a CC2LevelStateData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof LevelStateInfo.CC2LevelStateData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {LevelStateInfo.CC2LevelStateData} CC2LevelStateData
         */
        CC2LevelStateData.fromObject = function fromObject(object) {
            if (object instanceof $root.LevelStateInfo.CC2LevelStateData)
                return object;
            let message = new $root.LevelStateInfo.CC2LevelStateData();
            if (object.blobModifier != null)
                message.blobModifier = object.blobModifier | 0;
            if (object.scriptState != null) {
                if (typeof object.scriptState !== "object")
                    throw TypeError(".LevelStateInfo.CC2LevelStateData.scriptState: object expected");
                message.scriptState = $root.ScriptState.fromObject(object.scriptState);
            }
            return message;
        };

        /**
         * Creates a plain object from a CC2LevelStateData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof LevelStateInfo.CC2LevelStateData
         * @static
         * @param {LevelStateInfo.CC2LevelStateData} message CC2LevelStateData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CC2LevelStateData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.blobModifier = 0;
                object.scriptState = null;
            }
            if (message.blobModifier != null && message.hasOwnProperty("blobModifier"))
                object.blobModifier = message.blobModifier;
            if (message.scriptState != null && message.hasOwnProperty("scriptState"))
                object.scriptState = $root.ScriptState.toObject(message.scriptState, options);
            return object;
        };

        /**
         * Converts this CC2LevelStateData to JSON.
         * @function toJSON
         * @memberof LevelStateInfo.CC2LevelStateData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CC2LevelStateData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CC2LevelStateData
         * @function getTypeUrl
         * @memberof LevelStateInfo.CC2LevelStateData
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CC2LevelStateData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/LevelStateInfo.CC2LevelStateData";
        };

        return CC2LevelStateData;
    })();

    return LevelStateInfo;
})();

export const TilePositionInfo = $root.TilePositionInfo = (() => {

    /**
     * Properties of a TilePositionInfo.
     * @exports ITilePositionInfo
     * @interface ITilePositionInfo
     * @property {number|null} [x] TilePositionInfo x
     * @property {number|null} [y] TilePositionInfo y
     */

    /**
     * Constructs a new TilePositionInfo.
     * @exports TilePositionInfo
     * @classdesc A location in the level
     * @implements ITilePositionInfo
     * @constructor
     * @param {ITilePositionInfo=} [properties] Properties to set
     */
    function TilePositionInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TilePositionInfo x.
     * @member {number} x
     * @memberof TilePositionInfo
     * @instance
     */
    TilePositionInfo.prototype.x = 0;

    /**
     * TilePositionInfo y.
     * @member {number} y
     * @memberof TilePositionInfo
     * @instance
     */
    TilePositionInfo.prototype.y = 0;

    /**
     * Creates a new TilePositionInfo instance using the specified properties.
     * @function create
     * @memberof TilePositionInfo
     * @static
     * @param {ITilePositionInfo=} [properties] Properties to set
     * @returns {TilePositionInfo} TilePositionInfo instance
     */
    TilePositionInfo.create = function create(properties) {
        return new TilePositionInfo(properties);
    };

    /**
     * Encodes the specified TilePositionInfo message. Does not implicitly {@link TilePositionInfo.verify|verify} messages.
     * @function encode
     * @memberof TilePositionInfo
     * @static
     * @param {ITilePositionInfo} message TilePositionInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TilePositionInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.x != null && Object.hasOwnProperty.call(message, "x"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.x);
        if (message.y != null && Object.hasOwnProperty.call(message, "y"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.y);
        return writer;
    };

    /**
     * Encodes the specified TilePositionInfo message, length delimited. Does not implicitly {@link TilePositionInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TilePositionInfo
     * @static
     * @param {ITilePositionInfo} message TilePositionInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TilePositionInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TilePositionInfo message from the specified reader or buffer.
     * @function decode
     * @memberof TilePositionInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TilePositionInfo} TilePositionInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TilePositionInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TilePositionInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.x = reader.uint32();
                    break;
                }
            case 2: {
                    message.y = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TilePositionInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TilePositionInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TilePositionInfo} TilePositionInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TilePositionInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TilePositionInfo message.
     * @function verify
     * @memberof TilePositionInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TilePositionInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.x != null && message.hasOwnProperty("x"))
            if (!$util.isInteger(message.x))
                return "x: integer expected";
        if (message.y != null && message.hasOwnProperty("y"))
            if (!$util.isInteger(message.y))
                return "y: integer expected";
        return null;
    };

    /**
     * Creates a TilePositionInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TilePositionInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TilePositionInfo} TilePositionInfo
     */
    TilePositionInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.TilePositionInfo)
            return object;
        let message = new $root.TilePositionInfo();
        if (object.x != null)
            message.x = object.x >>> 0;
        if (object.y != null)
            message.y = object.y >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a TilePositionInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TilePositionInfo
     * @static
     * @param {TilePositionInfo} message TilePositionInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TilePositionInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.x = 0;
            object.y = 0;
        }
        if (message.x != null && message.hasOwnProperty("x"))
            object.x = message.x;
        if (message.y != null && message.hasOwnProperty("y"))
            object.y = message.y;
        return object;
    };

    /**
     * Converts this TilePositionInfo to JSON.
     * @function toJSON
     * @memberof TilePositionInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TilePositionInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for TilePositionInfo
     * @function getTypeUrl
     * @memberof TilePositionInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    TilePositionInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TilePositionInfo";
    };

    return TilePositionInfo;
})();

export const GlitchInfo = $root.GlitchInfo = (() => {

    /**
     * Properties of a GlitchInfo.
     * @exports IGlitchInfo
     * @interface IGlitchInfo
     * @property {GlitchInfo.KnownGlitches|null} [glitchKind] GlitchInfo glitchKind
     * @property {ITilePositionInfo|null} [location] GlitchInfo location
     * @property {number|null} [specifier] A miscellaneous glitch subtype specifier (eg. despawn replace vs delete)
     * @property {google.protobuf.IDuration|null} [happensAt] Time (absolute, since 0) when the glitch happens
     */

    /**
     * Constructs a new GlitchInfo.
     * @exports GlitchInfo
     * @classdesc A message describing a glitch used in a solution
     * @implements IGlitchInfo
     * @constructor
     * @param {IGlitchInfo=} [properties] Properties to set
     */
    function GlitchInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GlitchInfo glitchKind.
     * @member {GlitchInfo.KnownGlitches} glitchKind
     * @memberof GlitchInfo
     * @instance
     */
    GlitchInfo.prototype.glitchKind = 0;

    /**
     * GlitchInfo location.
     * @member {ITilePositionInfo|null|undefined} location
     * @memberof GlitchInfo
     * @instance
     */
    GlitchInfo.prototype.location = null;

    /**
     * A miscellaneous glitch subtype specifier (eg. despawn replace vs delete)
     * @member {number} specifier
     * @memberof GlitchInfo
     * @instance
     */
    GlitchInfo.prototype.specifier = 0;

    /**
     * Time (absolute, since 0) when the glitch happens
     * @member {google.protobuf.IDuration|null|undefined} happensAt
     * @memberof GlitchInfo
     * @instance
     */
    GlitchInfo.prototype.happensAt = null;

    /**
     * Creates a new GlitchInfo instance using the specified properties.
     * @function create
     * @memberof GlitchInfo
     * @static
     * @param {IGlitchInfo=} [properties] Properties to set
     * @returns {GlitchInfo} GlitchInfo instance
     */
    GlitchInfo.create = function create(properties) {
        return new GlitchInfo(properties);
    };

    /**
     * Encodes the specified GlitchInfo message. Does not implicitly {@link GlitchInfo.verify|verify} messages.
     * @function encode
     * @memberof GlitchInfo
     * @static
     * @param {IGlitchInfo} message GlitchInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GlitchInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.glitchKind != null && Object.hasOwnProperty.call(message, "glitchKind"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.glitchKind);
        if (message.location != null && Object.hasOwnProperty.call(message, "location"))
            $root.TilePositionInfo.encode(message.location, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.specifier != null && Object.hasOwnProperty.call(message, "specifier"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.specifier);
        if (message.happensAt != null && Object.hasOwnProperty.call(message, "happensAt"))
            $root.google.protobuf.Duration.encode(message.happensAt, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified GlitchInfo message, length delimited. Does not implicitly {@link GlitchInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GlitchInfo
     * @static
     * @param {IGlitchInfo} message GlitchInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GlitchInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GlitchInfo message from the specified reader or buffer.
     * @function decode
     * @memberof GlitchInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GlitchInfo} GlitchInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GlitchInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GlitchInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.glitchKind = reader.int32();
                    break;
                }
            case 2: {
                    message.location = $root.TilePositionInfo.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.specifier = reader.int32();
                    break;
                }
            case 4: {
                    message.happensAt = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GlitchInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GlitchInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GlitchInfo} GlitchInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GlitchInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GlitchInfo message.
     * @function verify
     * @memberof GlitchInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GlitchInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.glitchKind != null && message.hasOwnProperty("glitchKind"))
            switch (message.glitchKind) {
            default:
                return "glitchKind: enum value expected";
            case 0:
            case 1:
            case 3:
            case 6:
                break;
            }
        if (message.location != null && message.hasOwnProperty("location")) {
            let error = $root.TilePositionInfo.verify(message.location);
            if (error)
                return "location." + error;
        }
        if (message.specifier != null && message.hasOwnProperty("specifier"))
            if (!$util.isInteger(message.specifier))
                return "specifier: integer expected";
        if (message.happensAt != null && message.hasOwnProperty("happensAt")) {
            let error = $root.google.protobuf.Duration.verify(message.happensAt);
            if (error)
                return "happensAt." + error;
        }
        return null;
    };

    /**
     * Creates a GlitchInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GlitchInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GlitchInfo} GlitchInfo
     */
    GlitchInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.GlitchInfo)
            return object;
        let message = new $root.GlitchInfo();
        switch (object.glitchKind) {
        default:
            if (typeof object.glitchKind === "number") {
                message.glitchKind = object.glitchKind;
                break;
            }
            break;
        case "INVALID":
        case 0:
            message.glitchKind = 0;
            break;
        case "DESPAWN":
        case 1:
            message.glitchKind = 1;
            break;
        case "DYNAMITE_EXPLOSION_SNEAKING":
        case 3:
            message.glitchKind = 3;
            break;
        case "SIMULTANEOUS_CHARACTER_MOVEMENT":
        case 6:
            message.glitchKind = 6;
            break;
        }
        if (object.location != null) {
            if (typeof object.location !== "object")
                throw TypeError(".GlitchInfo.location: object expected");
            message.location = $root.TilePositionInfo.fromObject(object.location);
        }
        if (object.specifier != null)
            message.specifier = object.specifier | 0;
        if (object.happensAt != null) {
            if (typeof object.happensAt !== "object")
                throw TypeError(".GlitchInfo.happensAt: object expected");
            message.happensAt = $root.google.protobuf.Duration.fromObject(object.happensAt);
        }
        return message;
    };

    /**
     * Creates a plain object from a GlitchInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GlitchInfo
     * @static
     * @param {GlitchInfo} message GlitchInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GlitchInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.glitchKind = options.enums === String ? "INVALID" : 0;
            object.location = null;
            object.specifier = 0;
            object.happensAt = null;
        }
        if (message.glitchKind != null && message.hasOwnProperty("glitchKind"))
            object.glitchKind = options.enums === String ? $root.GlitchInfo.KnownGlitches[message.glitchKind] === undefined ? message.glitchKind : $root.GlitchInfo.KnownGlitches[message.glitchKind] : message.glitchKind;
        if (message.location != null && message.hasOwnProperty("location"))
            object.location = $root.TilePositionInfo.toObject(message.location, options);
        if (message.specifier != null && message.hasOwnProperty("specifier"))
            object.specifier = message.specifier;
        if (message.happensAt != null && message.hasOwnProperty("happensAt"))
            object.happensAt = $root.google.protobuf.Duration.toObject(message.happensAt, options);
        return object;
    };

    /**
     * Converts this GlitchInfo to JSON.
     * @function toJSON
     * @memberof GlitchInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GlitchInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GlitchInfo
     * @function getTypeUrl
     * @memberof GlitchInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GlitchInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GlitchInfo";
    };

    /**
     * KnownGlitches enum.
     * @name GlitchInfo.KnownGlitches
     * @enum {number}
     * @property {number} INVALID=0 INVALID value
     * @property {number} DESPAWN=1 DESPAWN value
     * @property {number} DYNAMITE_EXPLOSION_SNEAKING=3 DYNAMITE_EXPLOSION_SNEAKING value
     * @property {number} SIMULTANEOUS_CHARACTER_MOVEMENT=6 SIMULTANEOUS_CHARACTER_MOVEMENT value
     */
    GlitchInfo.KnownGlitches = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "INVALID"] = 0;
        values[valuesById[1] = "DESPAWN"] = 1;
        values[valuesById[3] = "DYNAMITE_EXPLOSION_SNEAKING"] = 3;
        values[valuesById[6] = "SIMULTANEOUS_CHARACTER_MOVEMENT"] = 6;
        return values;
    })();

    return GlitchInfo;
})();

/**
 * ProtoDirection enum.
 * @exports ProtoDirection
 * @enum {number}
 * @property {number} INVALID=0 INVALID value
 * @property {number} UP=1 UP value
 * @property {number} RIGHT=2 RIGHT value
 * @property {number} DOWN=3 DOWN value
 * @property {number} LEFT=4 LEFT value
 */
export const ProtoDirection = $root.ProtoDirection = (() => {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "INVALID"] = 0;
    values[valuesById[1] = "UP"] = 1;
    values[valuesById[2] = "RIGHT"] = 2;
    values[valuesById[3] = "DOWN"] = 3;
    values[valuesById[4] = "LEFT"] = 4;
    return values;
})();

export const google = $root.google = (() => {

    /**
     * Namespace google.
     * @exports google
     * @namespace
     */
    const google = {};

    google.protobuf = (function() {

        /**
         * Namespace protobuf.
         * @memberof google
         * @namespace
         */
        const protobuf = {};

        protobuf.Duration = (function() {

            /**
             * Properties of a Duration.
             * @memberof google.protobuf
             * @interface IDuration
             * @property {number|null} [seconds] Duration seconds
             * @property {number|null} [nanos] Duration nanos
             */

            /**
             * Constructs a new Duration.
             * @memberof google.protobuf
             * @classdesc Represents a Duration.
             * @implements IDuration
             * @constructor
             * @param {google.protobuf.IDuration=} [properties] Properties to set
             */
            function Duration(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Duration seconds.
             * @member {number} seconds
             * @memberof google.protobuf.Duration
             * @instance
             */
            Duration.prototype.seconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Duration nanos.
             * @member {number} nanos
             * @memberof google.protobuf.Duration
             * @instance
             */
            Duration.prototype.nanos = 0;

            /**
             * Creates a new Duration instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Duration
             * @static
             * @param {google.protobuf.IDuration=} [properties] Properties to set
             * @returns {google.protobuf.Duration} Duration instance
             */
            Duration.create = function create(properties) {
                return new Duration(properties);
            };

            /**
             * Encodes the specified Duration message. Does not implicitly {@link google.protobuf.Duration.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Duration
             * @static
             * @param {google.protobuf.IDuration} message Duration message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Duration.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.seconds != null && Object.hasOwnProperty.call(message, "seconds"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.seconds);
                if (message.nanos != null && Object.hasOwnProperty.call(message, "nanos"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.nanos);
                return writer;
            };

            /**
             * Encodes the specified Duration message, length delimited. Does not implicitly {@link google.protobuf.Duration.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.Duration
             * @static
             * @param {google.protobuf.IDuration} message Duration message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Duration.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Duration message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Duration
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Duration} Duration
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Duration.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Duration();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.seconds = reader.int64();
                            break;
                        }
                    case 2: {
                            message.nanos = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Duration message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.Duration
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.Duration} Duration
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Duration.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Duration message.
             * @function verify
             * @memberof google.protobuf.Duration
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Duration.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.seconds != null && message.hasOwnProperty("seconds"))
                    if (!$util.isInteger(message.seconds) && !(message.seconds && $util.isInteger(message.seconds.low) && $util.isInteger(message.seconds.high)))
                        return "seconds: integer|Long expected";
                if (message.nanos != null && message.hasOwnProperty("nanos"))
                    if (!$util.isInteger(message.nanos))
                        return "nanos: integer expected";
                return null;
            };

            /**
             * Creates a Duration message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Duration
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Duration} Duration
             */
            Duration.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.Duration)
                    return object;
                let message = new $root.google.protobuf.Duration();
                if (object.seconds != null)
                    if ($util.Long)
                        (message.seconds = $util.Long.fromValue(object.seconds)).unsigned = false;
                    else if (typeof object.seconds === "string")
                        message.seconds = parseInt(object.seconds, 10);
                    else if (typeof object.seconds === "number")
                        message.seconds = object.seconds;
                    else if (typeof object.seconds === "object")
                        message.seconds = new $util.LongBits(object.seconds.low >>> 0, object.seconds.high >>> 0).toNumber();
                if (object.nanos != null)
                    message.nanos = object.nanos | 0;
                return message;
            };

            /**
             * Creates a plain object from a Duration message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Duration
             * @static
             * @param {google.protobuf.Duration} message Duration
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Duration.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.seconds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.seconds = options.longs === String ? "0" : 0;
                    object.nanos = 0;
                }
                if (message.seconds != null && message.hasOwnProperty("seconds"))
                    if (typeof message.seconds === "number")
                        object.seconds = options.longs === String ? String(message.seconds) : message.seconds;
                    else
                        object.seconds = options.longs === String ? $util.Long.prototype.toString.call(message.seconds) : options.longs === Number ? new $util.LongBits(message.seconds.low >>> 0, message.seconds.high >>> 0).toNumber() : message.seconds;
                if (message.nanos != null && message.hasOwnProperty("nanos"))
                    object.nanos = message.nanos;
                return object;
            };

            /**
             * Converts this Duration to JSON.
             * @function toJSON
             * @memberof google.protobuf.Duration
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Duration.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Duration
             * @function getTypeUrl
             * @memberof google.protobuf.Duration
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Duration.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/google.protobuf.Duration";
            };

            return Duration;
        })();

        protobuf.Timestamp = (function() {

            /**
             * Properties of a Timestamp.
             * @memberof google.protobuf
             * @interface ITimestamp
             * @property {number|null} [seconds] Timestamp seconds
             * @property {number|null} [nanos] Timestamp nanos
             */

            /**
             * Constructs a new Timestamp.
             * @memberof google.protobuf
             * @classdesc Represents a Timestamp.
             * @implements ITimestamp
             * @constructor
             * @param {google.protobuf.ITimestamp=} [properties] Properties to set
             */
            function Timestamp(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Timestamp seconds.
             * @member {number} seconds
             * @memberof google.protobuf.Timestamp
             * @instance
             */
            Timestamp.prototype.seconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Timestamp nanos.
             * @member {number} nanos
             * @memberof google.protobuf.Timestamp
             * @instance
             */
            Timestamp.prototype.nanos = 0;

            /**
             * Creates a new Timestamp instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.ITimestamp=} [properties] Properties to set
             * @returns {google.protobuf.Timestamp} Timestamp instance
             */
            Timestamp.create = function create(properties) {
                return new Timestamp(properties);
            };

            /**
             * Encodes the specified Timestamp message. Does not implicitly {@link google.protobuf.Timestamp.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.ITimestamp} message Timestamp message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Timestamp.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.seconds != null && Object.hasOwnProperty.call(message, "seconds"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.seconds);
                if (message.nanos != null && Object.hasOwnProperty.call(message, "nanos"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.nanos);
                return writer;
            };

            /**
             * Encodes the specified Timestamp message, length delimited. Does not implicitly {@link google.protobuf.Timestamp.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.ITimestamp} message Timestamp message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Timestamp.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Timestamp message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Timestamp} Timestamp
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Timestamp.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Timestamp();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.seconds = reader.int64();
                            break;
                        }
                    case 2: {
                            message.nanos = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Timestamp message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.Timestamp} Timestamp
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Timestamp.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Timestamp message.
             * @function verify
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Timestamp.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.seconds != null && message.hasOwnProperty("seconds"))
                    if (!$util.isInteger(message.seconds) && !(message.seconds && $util.isInteger(message.seconds.low) && $util.isInteger(message.seconds.high)))
                        return "seconds: integer|Long expected";
                if (message.nanos != null && message.hasOwnProperty("nanos"))
                    if (!$util.isInteger(message.nanos))
                        return "nanos: integer expected";
                return null;
            };

            /**
             * Creates a Timestamp message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Timestamp} Timestamp
             */
            Timestamp.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.Timestamp)
                    return object;
                let message = new $root.google.protobuf.Timestamp();
                if (object.seconds != null)
                    if ($util.Long)
                        (message.seconds = $util.Long.fromValue(object.seconds)).unsigned = false;
                    else if (typeof object.seconds === "string")
                        message.seconds = parseInt(object.seconds, 10);
                    else if (typeof object.seconds === "number")
                        message.seconds = object.seconds;
                    else if (typeof object.seconds === "object")
                        message.seconds = new $util.LongBits(object.seconds.low >>> 0, object.seconds.high >>> 0).toNumber();
                if (object.nanos != null)
                    message.nanos = object.nanos | 0;
                return message;
            };

            /**
             * Creates a plain object from a Timestamp message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.Timestamp} message Timestamp
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Timestamp.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.seconds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.seconds = options.longs === String ? "0" : 0;
                    object.nanos = 0;
                }
                if (message.seconds != null && message.hasOwnProperty("seconds"))
                    if (typeof message.seconds === "number")
                        object.seconds = options.longs === String ? String(message.seconds) : message.seconds;
                    else
                        object.seconds = options.longs === String ? $util.Long.prototype.toString.call(message.seconds) : options.longs === Number ? new $util.LongBits(message.seconds.low >>> 0, message.seconds.high >>> 0).toNumber() : message.seconds;
                if (message.nanos != null && message.hasOwnProperty("nanos"))
                    object.nanos = message.nanos;
                return object;
            };

            /**
             * Converts this Timestamp to JSON.
             * @function toJSON
             * @memberof google.protobuf.Timestamp
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Timestamp.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Timestamp
             * @function getTypeUrl
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Timestamp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/google.protobuf.Timestamp";
            };

            return Timestamp;
        })();

        return protobuf;
    })();

    return google;
})();

export { $root as default };
